<template>
    <div class="section-post-creator">
    
        <header>
            <div class="container-title">
                <h2 class="title">{{title}}</h2>
                <p v-if="!previewEnabled && mode == 'create'" class="switchOldVersion" @click="switchInterface">Passez à l'ancienne version</p>
                <p v-else-if="mode !== 'create'" class="switchOldVersion" @click="$router.push('/dash/planner');">Retour au planner</p>
            </div>
            <div class="custom-edtion-mode" v-if="!previewEnabled">
             
                <h5 @click="handleChangeSelectorMode(!selectorMode.active)">Mode personnalisation</h5>
        
                <ComponentSwitch :value="selectorMode.active" :onChange="(value)=>handleChangeSelectorMode(value)" :id="'switchEditionMode'"></ComponentSwitch>
                <p class="state-edition-mode" @click="handleChangeSelectorMode(!selectorMode.active)">
                    {{selectorMode.active ? 'activé' : 'désactivé' }}
                </p>

                <div class="tutorial" v-if="!selectorMode.active && showTutorial">
                    <svg width="29" height="31" viewBox="0 0 29 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.61478 29.4303C3.46662 10.3949 6.9428 1.2045 27.9404 0.99937M7.61478 29.4303L1.21998 23.77M7.61478 29.4303L12.2981 22.1357" stroke="#B64985" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    Apporter des modifications uniquement<br> aux comptes sélectionnés.
                </div>
            </div>
            <div class="btns-action">

                <template v-if="!previewEnabled">
                    <div class="btn-outline-primary" @click="()=>saveDraft()">{{{ create : 'Mise en brouillon',duplicate : 'Mise en brouillon', edit: 'Convertir en brouillon', draft : 'Enregistrer'}[mode || 'create']}}</div>
                    <div class="btn-secondary icon-r " @click="()=>handlerChangePreviewDisplay(true)">{{ textSwitchPreview }}<i class="fa-solid fa-arrow-right"></i></div>
                </template>

                <template v-else>
                    <div class="btn-outline-primary" @click="()=>handlerChangePreviewDisplay(false)">Retour</div>
                    <div v-if="textBtnFinish" class="btn-secondary icon-r " @click="sendPostAllPost">{{textBtnFinish}}<i class="fa-solid fa-arrow-right"></i></div>
                    <div v-else  class="btn-secondary icon-r disable">{{textSwitchPreview}}<i class="fa-solid fa-arrow-right"></i></div>
                </template>
                
            
            </div>
        </header>
        <div :class="'post-creator '+formShow" ref="postCreator" >
            <div class="container-form" v-if="formShow == 'formMultiple'">
                <div class="nav-type-post">
                    <div class="icon-l" :class="{['btn-primary'] : typePostSelected == 'standard'}"><i class="fa-solid fa-pen-to-square"></i>Standard</div>
                    <div class="icon-l" :class="{['btn-primary'] : typePostSelected == 'story'}"><i class="fa-solid fa-camera-retro"></i>Story</div>
                </div>
                <div class="list-pages-selected hide-scrollbar">
                    <div class="btn-add-post" :class="{retract: pagesSelected.length}" @click="addNetwork">
                        <i class="fa-solid fa-plus"></i>
                        <p>Ajoutez des pages</p>
                    </div>   
                    <Avatar v-for="page in pagesSelected" :urlPicture="page.avatar" :typeNetwork="page.network" :key="page.id"></Avatar>
                </div>          
                <Form 
                    @setSelectTypeRenderNetwork="selectTypeNetwork" 
                    @updloadFile="uploadFileWithProgress"
                    :typeRenderNetworkSelected="typeNetworkSelected"
                    :formData="formData"
                    :uploadFilesServer="uploadFilesServer"
                    :networksSelected="networksSelected"
                    >
                </Form>
            </div>
            
            <div class="container-phone" ref="containerPhone">
                <div class="nav-type-network" v-if="!selectorMode.active">
                    <div class="list-network">
                        <Tooltip v-if="networksSelected.has('facebook')" :text="postNetworkIsValid.facebook.error.length ? postNetworkIsValid.facebook.error[0].textError : ''" :active="!postNetworkIsValid.facebook.showRender" position="left">
                            <div class="network" :class="{active: typeNetworkSelected == 'facebook', disable : !postNetworkIsValid.facebook.showRender}" @click="selectTypeNetwork('facebook')">
                                <Tooltip v-if="saveAllFormData.networks.facebook && postNetworkIsValid.facebook.showRender && Object.keys(saveAllFormData.networks.facebook).length > 0" :text="'Voir les modifications apportées'" position="right" :classCustom="'icon-edited'" @click="()=>{ handleChangeSelectorMode(true, 'facebook'); }">
                                    
                                </Tooltip>
                                <i class="fa-brands fa-facebook"></i>
                            </div>
                        </Tooltip>     
                        <Tooltip v-if="networksSelected.has('instagram')" :text="postNetworkIsValid.instagram.error.length ? postNetworkIsValid.instagram.error[0].textError : ''" :active="!postNetworkIsValid.instagram.showRender" position="left">     
                            <div class="network" :class="{active: typeNetworkSelected == 'instagram', disable : !postNetworkIsValid.instagram.showRender}" @click="selectTypeNetwork('instagram')">
                                <Tooltip v-if="saveAllFormData.networks.instagram && postNetworkIsValid.instagram.showRender && Object.keys(saveAllFormData.networks.instagram).length > 0" :text="'Voir les modifications apportées'" position="right" :classCustom="'icon-edited'" @click="()=>{ handleChangeSelectorMode(true, 'instagram'); }">
                                    
                                </Tooltip>
                                <i class="fa-brands fa-instagram" ></i>
                            </div>
                        </Tooltip> 
                        <Tooltip v-if="networksSelected.has('linkedin')" :text="postNetworkIsValid.linkedin.error.length ? postNetworkIsValid.linkedin.error[0].textError : ''" :active="!postNetworkIsValid.linkedin.showRender" position="left">    
                            <div class="network" :class="{active: typeNetworkSelected == 'linkedin', disable : !postNetworkIsValid.linkedin.showRender}" @click="selectTypeNetwork('linkedin')">
                                <Tooltip v-if="saveAllFormData.networks.linkedin && postNetworkIsValid.linkedin.showRender && Object.keys(saveAllFormData.networks.linkedin).length > 0" :text="'Voir les modifications apportées'" position="right" :classCustom="'icon-edited'" @click="()=>{ handleChangeSelectorMode(true, 'linkedin'); }">
                                    
                                </Tooltip>
                                <i class="fa-brands fa-linkedin-in"></i>
                            </div>
                        </Tooltip> 
                        <Tooltip v-if="networksSelected.has('google')" :text="postNetworkIsValid.google.error.length ? postNetworkIsValid.google.error[0].textError : ''" :active="!postNetworkIsValid.google.showRender" position="left">    
                            <div class="network" :class="{active: typeNetworkSelected == 'google', disable : !postNetworkIsValid.google.showRender}" @click="selectTypeNetwork('google')">
                                <Tooltip v-if="saveAllFormData.networks.google && postNetworkIsValid.google.showRender && Object.keys(saveAllFormData.networks.google).length > 0" :text="'Voir les modifications apportées'" position="right" :classCustom="'icon-edited'" @click="()=>{ handleChangeSelectorMode(true, 'google'); }">
                                    
                                </Tooltip>
                                <i class="fa-brands fa-google"></i>
                            </div>
                        </Tooltip> 
                        <Tooltip v-if="networksSelected.has('threads')" :text="postNetworkIsValid.threads.error.length ? postNetworkIsValid.threads.error[0].textError : ''" :active="!postNetworkIsValid.threads.showRender" position="left">    
                            <div class="network threads" :class="{active: typeNetworkSelected == 'threads', disable : !postNetworkIsValid.threads.showRender}" @click="selectTypeNetwork('threads')">
                                <Tooltip v-if="saveAllFormData.networks.threads && postNetworkIsValid.threads.showRender && Object.keys(saveAllFormData.networks.threads).length > 0" :text="'Voir les modifications apportées'" position="right" :classCustom="'icon-edited'" @click="()=>{ handleChangeSelectorMode(true, 'threads'); }">
                                    
                                </Tooltip>
                                <svg aria-label="Threads" viewBox="0 0 192 192" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"><path class="x19hqcy" d="M141.537 88.9883C140.71 88.5919 139.87 88.2104 139.019 87.8451C137.537 60.5382 122.616 44.905 97.5619 44.745C97.4484 44.7443 97.3355 44.7443 97.222 44.7443C82.2364 44.7443 69.7731 51.1409 62.102 62.7807L75.881 72.2328C81.6116 63.5383 90.6052 61.6848 97.2286 61.6848C97.3051 61.6848 97.3819 61.6848 97.4576 61.6855C105.707 61.7381 111.932 64.1366 115.961 68.814C118.893 72.2193 120.854 76.925 121.825 82.8638C114.511 81.6207 106.601 81.2385 98.145 81.7233C74.3247 83.0954 59.0111 96.9879 60.0396 116.292C60.5615 126.084 65.4397 134.508 73.775 140.011C80.8224 144.663 89.899 146.938 99.3323 146.423C111.79 145.74 121.563 140.987 128.381 132.296C133.559 125.696 136.834 117.143 138.28 106.366C144.217 109.949 148.617 114.664 151.047 120.332C155.179 129.967 155.42 145.8 142.501 158.708C131.182 170.016 117.576 174.908 97.0135 175.059C74.2042 174.89 56.9538 167.575 45.7381 153.317C35.2355 139.966 29.8077 120.682 29.6052 96C29.8077 71.3178 35.2355 52.0336 45.7381 38.6827C56.9538 24.4249 74.2039 17.11 97.0132 16.9405C119.988 17.1113 137.539 24.4614 149.184 38.788C154.894 45.8136 159.199 54.6488 162.037 64.9503L178.184 60.6422C174.744 47.9622 169.331 37.0357 161.965 27.974C147.036 9.60668 125.202 0.195148 97.0695 0H96.9569C68.8816 0.19447 47.2921 9.6418 32.7883 28.0793C19.8819 44.4864 13.2244 67.3157 13.0007 95.9325L13 96L13.0007 96.0675C13.2244 124.684 19.8819 147.514 32.7883 163.921C47.2921 182.358 68.8816 191.806 96.9569 192H97.0695C122.03 191.827 139.624 185.292 154.118 170.811C173.081 151.866 172.51 128.119 166.26 113.541C161.776 103.087 153.227 94.5962 141.537 88.9883ZM98.4405 129.507C88.0005 130.095 77.1544 125.409 76.6196 115.372C76.2232 107.93 81.9158 99.626 99.0812 98.6368C101.047 98.5234 102.976 98.468 104.871 98.468C111.106 98.468 116.939 99.0737 122.242 100.233C120.264 124.935 108.662 128.946 98.4405 129.507Z"/></svg>
                            </div>
                        </Tooltip>     
                        <Tooltip v-if="networksSelected.has('twitter')" :text="postNetworkIsValid.twitter.error.length ? postNetworkIsValid.twitter.error[0].textError : ''" :active="!postNetworkIsValid.twitter.showRender" position="left">
                            <div class="network" :class="{active: typeNetworkSelected == 'twitter', disable : !postNetworkIsValid.twitter.showRender}"  @click="selectTypeNetwork('twitter')">
                                <Tooltip v-if="saveAllFormData.networks.twitter && postNetworkIsValid.twitter.showRender && Object.keys(saveAllFormData.networks.twitter).length > 0" :text="'Voir les modifications apportées'" position="right" :classCustom="'icon-edited'" @click="()=>{ handleChangeSelectorMode(true, 'twitter'); }">
                                    
                                </Tooltip>
                                <i class="fa-brands fa-twitter"></i>
                            </div>
                        </Tooltip>   
                        <Tooltip v-if="networksSelected.has('tiktok')" :text="postNetworkIsValid.tiktok.error.length ? postNetworkIsValid.tiktok.error[0].textError : ''" :active="!postNetworkIsValid.tiktok.showRender" position="left">  
                            <div class="network" :class="{active: typeNetworkSelected == 'tiktok', disable : !postNetworkIsValid.tiktok.showRender}" @click="selectTypeNetwork('tiktok')">
                                <Tooltip v-if="saveAllFormData.networks.tiktok && postNetworkIsValid.tiktok.showRender && Object.keys(saveAllFormData.networks.tiktok).length > 0" :text="'Voir les modifications apportées'" position="right" :classCustom="'icon-edited'" @click="()=>{ handleChangeSelectorMode(true, 'tiktok'); }">
                                    
                                </Tooltip>
                                <i class="fa-brands fa-tiktok"></i>
                            </div>
                        </Tooltip>  
                        <Tooltip v-if="networksSelected.has('youtube')" :text="postNetworkIsValid.youtube.error.length ? postNetworkIsValid.youtube.error[0].textError : ''" :active="!postNetworkIsValid.youtube.showRender" position="left">   
                            <div class="network" :class="{active: typeNetworkSelected == 'youtube', disable : !postNetworkIsValid.youtube.showRender}" @click="selectTypeNetwork('youtube')">
                                <Tooltip v-if="saveAllFormData.networks.youtube && postNetworkIsValid.youtube.showRender && Object.keys(saveAllFormData.networks.youtube).length > 0" :text="'Voir les modifications apportées'" position="right" :classCustom="'icon-edited'" @click="()=>{ handleChangeSelectorMode(true, 'youtube'); }">
                                    
                                </Tooltip>
                                <i class="fa-brands fa-youtube"></i>
                            </div>
                        </Tooltip> 
                        <Tooltip v-if="networksSelected.has('pinterest')" :text="postNetworkIsValid.pinterest.error.length ? postNetworkIsValid.pinterest.error[0].textError : ''" :active="!postNetworkIsValid.pinterest.showRender" position="left">    
                            <div class="network" :class="{active: typeNetworkSelected == 'pinterest', disable : !postNetworkIsValid.pinterest.showRender}" @click="selectTypeNetwork('pinterest')">
                                <Tooltip v-if="saveAllFormData.networks.pinterest && postNetworkIsValid.pinterest.showRender && Object.keys(saveAllFormData.networks.pinterest).length > 0" :text="'Voir les modifications apportées'" position="right" :classCustom="'icon-edited'" @click="()=>{ handleChangeSelectorMode(true, 'pinterest'); }">
                                    
                                </Tooltip>
                                <i class="fa-brands fa-pinterest"></i>
                            </div>
                        </Tooltip>  
                        <Tooltip v-if="networksSelected.has('telegram')" :text="postNetworkIsValid.telegram.error.length ? postNetworkIsValid.telegram.error[0].textError : ''" :active="!postNetworkIsValid.telegram.showRender" position="left">   
                            <div class="network" :class="{active: typeNetworkSelected == 'telegram', disable : !postNetworkIsValid.telegram.showRender}" @click="selectTypeNetwork('telegram')">
                                <Tooltip v-if="saveAllFormData.networks.telegram && postNetworkIsValid.telegram.showRender && Object.keys(saveAllFormData.networks.telegram).length > 0" :text="'Voir les modifications apportées'" position="right" :classCustom="'icon-edited'" @click="()=>{ handleChangeSelectorMode(true, 'telegram'); }">
                                    
                                </Tooltip>
                                <i class="fa-brands fa-telegram"></i>
                            </div>
                        </Tooltip>     

                    </div>
                </div>
                <Phone :firstPlan="phoneIsFirstPlan">

                    <renderPostFailed 
                        v-if="textPostFailed" 
                        :textError="textPostFailed"
                    />

                    <renderPostFacebook v-if="typeNetworkSelected == 'facebook'" 
                        :medias="filesSortByNetwork[typeNetworkSelected]" 
                        :pageName="getNamePageNetwork" 
                        :picturePages="(previewEnabled || (selectorMode.active && !selectorMode.selection.network) ? [selectorMode.selection.page] : pagesSelected).filter(p => p.network == 'facebook').map(p => ({id: p.id, avatar: p.avatar, iconEdited: saveAllFormData.pages[p.id] && Object.keys(saveAllFormData.pages[p.id]).length > 0 && !previewEnabled && (!selectorMode.active || !selectorMode.selection.page || selectorMode.selection.page.id !== p.id) ? true : false}))"
                        @clickPage="clickPageInRenderPost" 
                        :text="textContentConverted" 
                        :comment="textCommentConverted" 
                        :datePost="formData.planifiedDate ? formData.planifiedDate.timestamp : false"
                        :modes="modes"
                        :snippet="formData.formDataNetwork && formData.formDataNetwork.facebook && formData.formDataNetwork.facebook.snippet ? formData.formDataNetwork.facebook.snippet : undefined"
                        :mentions = "formData.mentions ? formData.mentions : {}"
                        :place="formData.formDataNetwork && formData.formDataNetwork.facebook && formData.formDataNetwork.facebook.place ? formData.formDataNetwork.facebook.place : undefined"
                        :positionFormOverlay="selectorMode.active ? 'right' : 'left'"
                    />

                    <renderReelInstagram v-else-if="typeNetworkSelected == 'instagram' && formData.files && formData.files.length == 1 && ['video/mp4'].includes(formData.files[0].type)" 
                        :medias="filesSortByNetwork[typeNetworkSelected]" 
                        :pageName="getNamePageNetwork" 
                        :picturePages="(previewEnabled || (selectorMode.active && !selectorMode.selection.network) ? [selectorMode.selection.page] : pagesSelected).filter(p => p.network == 'instagram').map(p => ({id: p.id, avatar: p.avatar, iconEdited: saveAllFormData.pages[p.id] && Object.keys(saveAllFormData.pages[p.id]).length > 0 && !previewEnabled && (!selectorMode.active || !selectorMode.selection.page || selectorMode.selection.page.id !== p.id) ? true : false}))"
                        @clickPage="clickPageInRenderPost" 
                        :musicName="'euro 2024 • Audio d\'origine'" 
                        :description="'This save 🤯 ... '"
                        :modes="modes" 
                        :mentions = "formData.mentions ? formData.mentions : {}"
                        :personsIdentified="formData.formDataNetwork && formData.formDataNetwork.instagram && formData.formDataNetwork.instagram.personsIdentified ? formData.formDataNetwork.instagram.personsIdentified  : []"
                        :collaborators="formData.formDataNetwork && formData.formDataNetwork.instagram && formData.formDataNetwork.instagram.collaborators ? formData.formDataNetwork.instagram.collaborators : []"
                        :positionFormOverlay="selectorMode.active ? 'right' : 'left'"
                        :music="formData.formDataNetwork && formData.formDataNetwork.instagram && formData.formDataNetwork.instagram.music ? formData.formDataNetwork.instagram.music : undefined"
                        :place="formData.formDataNetwork && formData.formDataNetwork.instagram && formData.formDataNetwork.instagram.place ? formData.formDataNetwork.instagram.place : undefined"
                    />

                    <renderPostInstagram v-else-if="typeNetworkSelected == 'instagram'" 
                        :medias="filesSortByNetwork[typeNetworkSelected]" 
                        :pageName="getNamePageNetwork" 
                        :picturePages="(previewEnabled || (selectorMode.active && !selectorMode.selection.network) ? [selectorMode.selection.page] : pagesSelected).filter(p => p.network == 'instagram').map(p => ({id: p.id, avatar: p.avatar, iconEdited: saveAllFormData.pages[p.id] && Object.keys(saveAllFormData.pages[p.id]).length > 0 && !previewEnabled && (!selectorMode.active || !selectorMode.selection.page || selectorMode.selection.page.id !== p.id) ? true : false}))"
                        @clickPage="clickPageInRenderPost" 
                        :text="textContentConverted" 
                        :comment="textCommentConverted" 
                        :datePost="formData.planifiedDate ? formData.planifiedDate.timestamp : false" 
                        :modes="modes" 
                        :personsIdentified="formData.formDataNetwork && formData.formDataNetwork.instagram && formData.formDataNetwork.instagram.personsIdentified ? formData.formDataNetwork.instagram.personsIdentified  : []"
                        :collaborators="formData.formDataNetwork && formData.formDataNetwork.instagram && formData.formDataNetwork.instagram.collaborators ? formData.formDataNetwork.instagram.collaborators : []"
                        :place="formData.formDataNetwork && formData.formDataNetwork.instagram && formData.formDataNetwork.instagram.place ? formData.formDataNetwork.instagram.place : undefined"
                        :music="formData.formDataNetwork && formData.formDataNetwork.instagram && formData.formDataNetwork.instagram.music ? formData.formDataNetwork.instagram.music : undefined"
                        :ratio="formData.formDataNetwork && formData.formDataNetwork.instagram && formData.formDataNetwork.instagram.ratio ? formData.formDataNetwork.instagram.ratio : undefined"
                        :mentions = "formData.mentions ? formData.mentions : {}"
                        :positionFormOverlay="selectorMode.active ? 'right' : 'left'"
                    />

                    <renderPostLinkedin v-else-if="typeNetworkSelected == 'linkedin'" 

                        :medias="filesSortByNetwork[typeNetworkSelected]" 
                        :survey="formData.formDataNetwork && formData.formDataNetwork.linkedin && formData.formDataNetwork.linkedin.survey && formData.formDataNetwork.linkedin.survey.active ?  formData.formDataNetwork.linkedin.survey : null"
                        :titlePdf="formData.formDataNetwork && formData.formDataNetwork.linkedin && formData.formDataNetwork.linkedin.pdf && formData.formDataNetwork.linkedin.pdf.title ?  formData.formDataNetwork.linkedin.pdf.title : null"
                        :pageName="getNamePageNetwork" 
                        :picturePages="(previewEnabled || (selectorMode.active && !selectorMode.selection.network) ? [selectorMode.selection.page] : pagesSelected).filter(p => p.network == 'linkedin').map(p => ({id: p.id, avatar: p.avatar, iconEdited: saveAllFormData.pages[p.id] && Object.keys(saveAllFormData.pages[p.id]).length > 0 && !previewEnabled && (!selectorMode.active || !selectorMode.selection.page || selectorMode.selection.page.id !== p.id) ? true : false}))"
                        @clickPage="clickPageInRenderPost" 
                        :text="textContentConverted" :comment="textCommentConverted" 
                        :datePost="formData.planifiedDate ? formData.planifiedDate.timestamp : false"
                        :snippet="formData.formDataNetwork && formData.formDataNetwork.linkedin && formData.formDataNetwork.linkedin.snippet && !formData.formDataNetwork.linkedin.survey.active ? formData.formDataNetwork.linkedin.snippet : undefined"
                        :mentions = "formData.mentions ? formData.mentions : {}"
                    />

                    <renderPostThreads  v-else-if="typeNetworkSelected == 'threads'" 
                        :medias="filesSortByNetwork[typeNetworkSelected]"
                        :pageName="getNamePageNetwork" 
                        :pageName2="getNamePageNetwork" 
                        :picturePages="(previewEnabled || (selectorMode.active && !selectorMode.selection.network) ? [selectorMode.selection.page] : pagesSelected).filter(p => p.network == 'threads').map(p => ({id: p.id, avatar: p.avatar, iconEdited: saveAllFormData.pages[p.id] && Object.keys(saveAllFormData.pages[p.id]).length > 0 && !previewEnabled && (!selectorMode.active || !selectorMode.selection.page || selectorMode.selection.page.id !== p.id) ? true : false}))"
                        @clickPage="clickPageInRenderPost" 
                        :text="textContentConverted" 
                        :comment="textCommentConverted" 
                        :datePost="formData.planifiedDate ? formData.planifiedDate.timestamp : false"
                        :snippet="formData.urlsTextContent.length ?
                                !formData.files.find(f => ['video','image'].includes(f.type2)) ?
                                    {link: formData.urlsTextContent[0]} 
                                    : {}
                            : formData.formDataNetwork && formData.formDataNetwork.threads && formData.formDataNetwork.threads.snippet ? 
                                formData.formDataNetwork.threads.snippet 
                                : undefined"
                        :mentions = "formData.mentions ? formData.mentions : {}"
                    />
        
                    <renderPostTwitter v-else-if="typeNetworkSelected == 'twitter'" 
                        :medias="filesSortByNetwork[typeNetworkSelected]" 
                        :pageName="getNamePageNetwork" 
                        :pageName2="getNamePageNetwork" 
                        :picturePages="(previewEnabled || (selectorMode.active && !selectorMode.selection.network) ? [selectorMode.selection.page] : pagesSelected).filter(p => p.network == 'twitter').map(p => ({id: p.id, avatar: p.avatar, iconEdited: saveAllFormData.pages[p.id] && Object.keys(saveAllFormData.pages[p.id]).length > 0 && !previewEnabled && (!selectorMode.active || !selectorMode.selection.page || selectorMode.selection.page.id !== p.id) ? true : false}))"
                        @clickPage="clickPageInRenderPost" 
                        :text="textContentConverted" 
                        :comment="textCommentConverted" 
                        :datePost="formData.planifiedDate ? formData.planifiedDate.timestamp : false"
                        :snippet="formData.formDataNetwork && formData.formDataNetwork.twitter && formData.formDataNetwork.twitter.snippet ? formData.formDataNetwork.twitter.snippet : undefined"
                        :mentions = "formData.mentions ? formData.mentions : {}"
                    />
                    
                    <renderPostTiktok v-else-if="typeNetworkSelected == 'tiktok'" 
                        :medias="filesSortByNetwork[typeNetworkSelected]" 
                        :pageName="getNamePageNetwork" 
                        :picturePages="(previewEnabled || (selectorMode.active && !selectorMode.selection.network) ? [selectorMode.selection.page] : pagesSelected).filter(p => p.network == 'tiktok').map(p => ({id: p.id, avatar: p.avatar, iconEdited: saveAllFormData.pages[p.id] && Object.keys(saveAllFormData.pages[p.id]).length > 0 && !previewEnabled && (!selectorMode.active || !selectorMode.selection.page || selectorMode.selection.page.id !== p.id) ? true : false}))"
                        @clickPage="clickPageInRenderPost" 
                        :musicName="'euro 2024 • Audio d\'origine'" 
                        :description="'This save 🤯 ... '">
                    </renderPostTiktok>

                    <renderPostGoogle v-else-if="typeNetworkSelected == 'google'" 
                        :medias="filesSortByNetwork[typeNetworkSelected]" 
                        :pageName="getNamePageNetwork" 
                        :picturePages="(previewEnabled || (selectorMode.active && !selectorMode.selection.network) ? [selectorMode.selection.page] : pagesSelected).filter(p => p.network == 'google').map(p => ({id: p.id, avatar: p.avatar, iconEdited: saveAllFormData.pages[p.id] && Object.keys(saveAllFormData.pages[p.id]).length > 0 && !previewEnabled && (!selectorMode.active || !selectorMode.selection.page || selectorMode.selection.page.id !== p.id) ? true : false}))"
                        @clickPage="clickPageInRenderPost" 
                        :text="textContentConverted" 
                        :datePost="formData.planifiedDate ? formData.planifiedDate.timestamp : false"
                        :snippet="formData.formDataNetwork && formData.formDataNetwork.google && formData.formDataNetwork.google.snippet ? formData.formDataNetwork.google.snippet : undefined"
                        :mentions = "formData.mentions ? formData.mentions : {}"
                    />

                    <renderPostTelegram v-else-if="typeNetworkSelected == 'telegram'" 
                        :medias="filesSortByNetwork[typeNetworkSelected]" 
                        :pageName="getNamePageNetwork" 
                        :picturePages="(previewEnabled || (selectorMode.active && !selectorMode.selection.network) ? [selectorMode.selection.page] : pagesSelected).filter(p => p.network == 'telegram').map(p => ({id: p.id, avatar: p.avatar, iconEdited: saveAllFormData.pages[p.id] && Object.keys(saveAllFormData.pages[p.id]).length > 0 && !previewEnabled && (!selectorMode.active || !selectorMode.selection.page || selectorMode.selection.page.id !== p.id) ? true : false}))"
                        @clickPage="clickPageInRenderPost" 
                        :text="textContentConverted" :comment="textCommentConverted" 
                        :datePost="formData.planifiedDate ? formData.planifiedDate.timestamp : false"
                        :snippet="formData.urlsTextContent && formData.urlsTextContent.length ? {link: formData.urlsTextContent[0]}: undefined"
                        :mentions = "formData.mentions ? formData.mentions : {}"
                    />

                    <renderPostPinterest v-else-if="typeNetworkSelected == 'pinterest'" 
                        :medias="filesSortByNetwork[typeNetworkSelected]" 
                        :pageName="getNamePageNetwork" 
                        :picturePages="(previewEnabled || (selectorMode.active && !selectorMode.selection.network) ? [selectorMode.selection.page] : pagesSelected).filter(p => p.network == 'pinterest').map(p => ({id: p.id, avatar: p.avatar, iconEdited: saveAllFormData.pages[p.id] && Object.keys(saveAllFormData.pages[p.id]).length > 0 && !previewEnabled && (!selectorMode.active || !selectorMode.selection.page || selectorMode.selection.page.id !== p.id) ? true : false}))"
                        @clickPage="clickPageInRenderPost" 
                        :title="textContentConverted ? textContentConverted.slice(0, 100).split('<br>')[0] : undefined"
                        :text="textContentConverted ? textContentConverted.split('<br>').slice(1).join('<br>') : undefined"
                        :comment="textCommentConverted" 
                        :datePost="formData.planifiedDate ? formData.planifiedDate.timestamp : false"
                        :snippet="formData.formDataNetwork && formData.formDataNetwork.pinterest && formData.formDataNetwork.pinterest.snippet ? formData.formDataNetwork.pinterest.snippet : undefined"
                        :mentions = "formData.mentions ? formData.mentions : {}"
                    />

                    <renderShortYoutube v-else-if="typeNetworkSelected == 'youtube' && (!formData.files.find(file => file.type2 == 'video') || formData.files.find(file => file.type2 == 'video').dimensions.aspectRatio == 0.5625)" 
                        :medias="filesSortByNetwork[typeNetworkSelected]" 
                        :pageName="getNamePageNetwork" 
                        :picturePages="(previewEnabled || (selectorMode.active && !selectorMode.selection.network) ? [selectorMode.selection.page] : pagesSelected).filter(p => p.network == 'youtube').map(p => ({id: p.id, avatar: p.avatar, iconEdited: saveAllFormData.pages[p.id] && Object.keys(saveAllFormData.pages[p.id]).length > 0 && !previewEnabled && (!selectorMode.active || !selectorMode.selection.page || selectorMode.selection.page.id !== p.id) ? true : false}))"
                        @clickPage="clickPageInRenderPost" 
                        :musicName="'euro 2024 • Audio d\'origine'" 
                        :description="'This save 🤯 ... '"
                    />

                    <renderPostYoutube v-else-if="typeNetworkSelected == 'youtube'" 
                        :medias="filesSortByNetwork[typeNetworkSelected]" 
                        :pageName="getNamePageNetwork" 
                        :picturePages="(previewEnabled || (selectorMode.active && !selectorMode.selection.network) ? [selectorMode.selection.page] : pagesSelected).filter(p => p.network == 'youtube').map(p => ({id: p.id, avatar: p.avatar, iconEdited: saveAllFormData.pages[p.id] && Object.keys(saveAllFormData.pages[p.id]).length > 0 && !previewEnabled && (!selectorMode.active || !selectorMode.selection.page || selectorMode.selection.page.id !== p.id) ? true : false}))"
                        @clickPage="clickPageInRenderPost" 
                        :title="textContentConverted ? textContentConverted.slice(0, 100).split('<br>')[0] : undefined"
                        :text="textContentConverted ? textContentConverted.split('<br>').slice(1).join('<br>') : undefined"
                        :comment="textCommentConverted" 
                        :datePost="formData.planifiedDate ? formData.planifiedDate.timestamp : false"
                        :mentions = "formData.mentions ? formData.mentions : {}"
                    />
     
                    <selectMention v-if="modes.includes('addMentionMode')" 
                        @close="removeMode" 
                        :position="selectorMode.active ? 'right' : 'left'"
                        :mentionData="dataMode.addMentionMode && dataMode.addMentionMode.mention ? dataMode.addMentionMode.mention : {}"
                        :idMention="dataMode.addMentionMode && dataMode.addMentionMode.idMention ? dataMode.addMentionMode.idMention : null"
                    />

                    <selectHashtag v-if="modes.includes('addHashtagMode')" 
                        @close="removeMode"
                        :position="selectorMode.active ? 'right' : 'left'"
                        :id="dataMode.addHashtagMode && dataMode.addHashtagMode.id ? dataMode.addHashtagMode.id : ''"
                    />
                </Phone>
                <div class="nav-page" v-if="selectorMode.active || previewEnabled">
                    <div class="list-page hide-scrollbar">
                        <template v-for="(networkName) in listNetworkSort">
                            <div class="group" v-if="pagesSelected.find(p => p.network == networkName)" :key="networkName" :class="{'active': selectorMode.selection.network && selectorMode.selection.network == networkName}">
                                <div class="network" 
                                    :class="{
                                        [networkName]:true, 
                                        edited: saveAllFormData.networks[networkName] && Object.keys(saveAllFormData.networks[networkName]).length > 0,
                                        failed: previewEnabled && pagesSelected.some(page => page.network == networkName && dataFormRequest[page.id] &&  dataFormRequest[page.id].error)
                                    }" 
                                    @click="() => selectNetworkForSelectorMode(networkName)"
                                >
                                    <Checkbox v-if="!previewEnabled && (!selectorMode.selection.network || selectorMode.selection.network !== networkName)" :isChecked="selectorMode.selection.network && selectorMode.selection.network == networkName" :add="selectNetworkForSelectorMode" :isDisable="selectorMode.selection.network && selectorMode.selection.network == networkName" :prefexId="'networkSelectorModePostCreator'+index" :id="networkName"></Checkbox>
                                </div>
                                <div class="list-avatar">
                                    <div class="container-avatar"
                                        v-for="page in pagesSelected.filter(p => p.network == networkName)" 
                                        :class="{
                                            checked: (selectorMode.selection.page && selectorMode.selection.page.id == page.id) || (selectorMode.selection.network && selectorMode.selection.network == networkName), 
                                            edited: !previewEnabled && saveAllFormData.pages[page.id] && Object.keys(saveAllFormData.pages[page.id]).length > 0,
                                            failed: previewEnabled && dataFormRequest[page.id] && dataFormRequest[page.id].error
                                        }"
                                        :key="page.id"
                                        >
                                        <Avatar @click="()=>toggleSelectPageForSelectorMode(page)" 
                                            :checkIsPossible="true" 
                                            :checked="(selectorMode.selection.page && selectorMode.selection.page.id == page.id) || (selectorMode.selection.network && selectorMode.selection.network == networkName)" 
                                            :urlPicture="page.avatar"
                                        />
                                    </div>
                                </div>
                            </div>   
                        </template>  
                    </div>
                </div>
            </div>          

            <template v-if="formShow == 'formUnique'" >

                <div class="container-form">
                    <Form 
                        :typeRenderNetworkSelected="selectorMode.selection.network ? selectorMode.selection.network : selectorMode.selection.page ? selectorMode.selection.page.network : typeNetworkSelected"
                        :idPageRenderNetworkSelected="selectorMode.selection.page && selectorMode.selection.page.id ? selectorMode.selection.page.id : null"
                        :formData="formData"
                        :uniqueNetworkForm="true"
                        :updateFormData="selectorMode.selection.network ? saveAllFormData.networks[selectorMode.selection.network] : selectorMode.selection.page ? saveAllFormData.pages[selectorMode.selection.page.id] : {}"
                        :uploadFilesServer="uploadFilesServer"
                        :networksSelected="networksSelected"
                        @setSelectTypeRenderNetwork="selectTypeNetwork" 
                        @saveFormData="saveFormData"
                        @restoreFormData="restoreFormData"
                        @updloadFile="uploadFileWithProgress"
                    ></Form>
                </div>
                <div></div>
            </template>
        </div>
    </div>
</template>

<script>
import { EventBus } from '@/event-bus';
import store from './../../../store/index.js';
import ComponentSwitch from '../utils/switch.vue';
import Avatar from '../utils/avatar.vue';
import Checkbox from '../utils/checkbox.vue';
import Phone from '../postCreator/Phone.vue';
import Form from '../postCreator/Form.vue';
import SelectPage from '../SelectPage.vue'
import selectMention from '../postCreator/formOverlay/selectMention.vue'
import selectHashtag from '../postCreator/formOverlay/selectHashtag.vue'
import Tooltip from './../tooltip/tooltipInit.vue'

import renderPostFailed from "../postCreator/renderPost/renderPostFailed.vue"
import renderPostInstagram from "../postCreator/renderPost/postInstagram.vue"
import renderReelInstagram from "../postCreator/renderPost/reelInstagram.vue"
import renderPostFacebook from "../postCreator/renderPost/postFacebook.vue"
import renderPostTwitter from "../postCreator/renderPost/postTwitter.vue"
import renderPostLinkedin from "../postCreator/renderPost/postLinkedin.vue"
import renderPostTiktok from "../postCreator/renderPost/postTiktok.vue"
import renderPostGoogle from "../postCreator/renderPost/postGoogle.vue"
import renderPostTelegram from "../postCreator/renderPost/postTelegram.vue"
import renderPostPinterest from "../postCreator/renderPost/postPinterest.vue"
import renderPostYoutube from "../postCreator/renderPost/postYoutube.vue"
import renderShortYoutube from "../postCreator/renderPost/shortYoutube.vue"
import renderPostThreads from "../postCreator/renderPost/postThreads.vue"
import { formDataDefault, maxFilesPerNetwork } from '../postCreator/constante.js'
import SSE from './../../../utils/sse.js'

import postMixin from './../../mixins/Posts.vue'
import draftMixin from './../../mixins/Drafts.vue'


const draftConstante = {
    "multipleImages":[],
    "multipleMedias":[],
    "activeMentionsAutoReplace":true,
    "activeHashtagsAutoAdd":true,
    "validMentions":[],
    "mentionsAdded":[],
    "hashtagsAdded":[],
    "activePrefixSuffix":false,
    "layers":[],
    "carrouselRatio":1,
    "instagramTexts":[],
    "instagramTextsUpdater":[],
    "storyLinkText":"",
    "snippetTitle":"",
    "snippet":null,
    "carouselOrderDragElement":null,
    "poll":{"question":"","options":["",""],"duration":604800},
    "templateManual":null,
    "instagramLinkPosition":{"x":160,"y":440,"color":0},
    "highlightInstagram":null,
    "instagramBackgroundColor":null,
    "sharedStoryUrl":"",
    "storySharedVisual":null,
    "screenshot":null,
    "videoReel":true,
    "videoReelFB":false,
    "videos":"{\"twitter\":null,\"facebook\":null,\"facebook_reel\":null,\"linkedin\":null,\"instagram\":null,\"instagram_reel\":null,\"story\":null}",
    "location":null,
    "userTags":null,
    "storyVideo":false,
    "pollStory":null,
    "sliderStory":null,
    "musicStory":null,
    "gifsStory":[],
    "mentionsWidget":[],
    "filename":null,
    "videoname":null,
    "validHashtags":[],
    "storyMultiple":[],
    "shareAfterPost":false,
    "storificationData":{"link":null},
    "storyShareToFacebook":false,
    "compressedImages":[],
    "tiktokOptions":"{\"comment_disabled\":false,\"duet_disabled\":true,\"stitch_disabled\":true,\"privacy_level\":\"SELF_ONLY\"}",
    "youtubeOptions":"{\"notifySubscribers\":true,\"madeForKids\":false,\"privacy_level\":\"public\",\"category\":\"22\",\"tag\":\"\",\"tags\":[],\"playlist\":null}",
    "log":["{\"user\":{\"id\":\"a79437f2-b92a-4213-909e-a267a7accfb3\",\"name\":\"Guilloux Clementooo\",\"email\":\"clement@mashup-web.com\",\"avatar\":\"https://s3-eu-west-1.amazonaws.com/saas.mashup/uploads/09kcdi7v6b9n-1530533447961.jpg\"},\"isDraft\":true,\"created_at\":\"2024-10-17T18:47:35+02:00\"}"],
    "typePost": "standard",
}


export default {
    components: {
        ComponentSwitch,
        Phone,
        Form,
        Avatar,
        Checkbox,
        SelectPage,
        selectMention,
        selectHashtag,
        renderPostFailed,
        renderPostInstagram,
        renderReelInstagram,
        renderPostFacebook,
        renderPostTwitter,
        renderPostLinkedin,
        renderPostTiktok,
        renderPostGoogle,
        renderPostTelegram,
        renderPostPinterest,
        renderPostYoutube,
        renderShortYoutube,
        renderPostThreads,
        Tooltip
    },
    mixins: [postMixin, draftMixin],

    props: {
        mode: String,
    },

    data() {
        return {
           
            listNetworkSort: ['facebook','instagram','linkedin','google','threads','twitter','tiktok','youtube','pinterest','telegram'],
           
            selectorMode: {
                active : false,
                selection : {
                    network: null,
                    page: null
                }
             
            },
            formShow: "formMultiple",// pour l'annimation
            timeOutAnnimateForm: null,

            typePostSelected: "standard",
            typeNetworkSelected: "",
            
            saveAllFormData:{
                main: {},
                networks: {},
                pages: {},
               
            },

            previewEnabled : false,

            formData : { ...formDataDefault },

            //la list mode est connu et modifiable par tout les interfaces Network et les deux formulaires 
            modes : [],
            dataMode : {},

            uploadFilesServer : {

            },

            dataFormRequest : {},

            showTutorial : !localStorage.postCreatorCountUseSelectorMode ? true : localStorage.postCreatorCountUseSelectorMode < 3,

            dataEditPost: {},
            draft: {}
        }
    },


    mounted() {
        EventBus.$on('postCreatorAddMode', this.addMode);
        EventBus.$on('postCreatorRemoveMode', this.removeMode);
        this.updateTypeNetworkSelected()

        try {
            switch (this.mode) {
                case 'edit': {

                    this.dataEditPost = this.$store.getters['postCreator/getDataEditPost'];
                    if (this.dataEditPost.draft && this.dataEditPost.draft.saveAllFormData && this.dataEditPost.draft.uploadFilesServer) {
                        this.uploadFilesServer = this.dataEditPost.draft.uploadFilesServer
                        this.saveAllFormData = this.dataEditPost.draft.saveAllFormData
                        this.formData = this.dataEditPost.draft.saveAllFormData.main
                        //enlever de la section les pages déja publié, regarder dans saveAllFormData.page[id] ou dans saveAllFormData.networks[]
                        this.$store.commit('selectPage/updateSelectPagePageSelected', this.dataEditPost.posts.map(post => this.allPages.find(page => page.id == post.page)).filter(page => page || false));

                        EventBus.$on('deletePostFromClickSelectPage', this.deletePostFromClickSelectPage);
                    }else{
                        throw new Error("Edition impossible");
                    }
                    
                    break;
                }
                case 'duplicate': {
                    const dataDuplicatePost = this.$store.getters['postCreator/getDataDuplicatePost'];
                    if (dataDuplicatePost.draft && dataDuplicatePost.draft.saveAllFormData && dataDuplicatePost.draft.uploadFilesServer) {
                        this.uploadFilesServer = dataDuplicatePost.draft.uploadFilesServer
                        this.saveAllFormData = dataDuplicatePost.draft.saveAllFormData
                        this.formData = dataDuplicatePost.draft.saveAllFormData.main
                        this.$store.commit('selectPage/updateSelectPagePageSelected', dataDuplicatePost.pages.map(pageId => this.allPages.find(page => page.id == pageId)).filter(page => page || false));
                    }else{
                        throw new Error("Duplication impossible");
                    }
                    break;
                }
                case 'draft': {
                    this.draft = this.$store.getters['postCreator/getDataDraft'];
                    if (this.draft.id && this.draft.data.saveAllFormData && this.draft.data.uploadFilesServer) {
                        this.uploadFilesServer = this.draft.data.uploadFilesServer
                        this.saveAllFormData =  this.draft.data.saveAllFormData
                        this.formData = this.draft.data.saveAllFormData.main
                        this.$store.commit('selectPage/updateSelectPagePageSelected', this.draft.data.pages.map(pageId => this.allPages.find(page => page.id == pageId)).filter(page => page || false));
                    }else{
                        throw new Error("Impossible de charger le draft");
                    }
                    break;
                }
                default: {
                    throw new Error("Impossible de charger le mode");
                }
                    
            }
        } catch (error) {
            this.$router.push('/dash/postCreator');
        }
       
    },

    methods: {
        handleChangeSelectorMode(state, network = null, page = null) {
            this.$set(this.selectorMode,'active',state);

            if (state) {
                this.saveAllFormData.main = this.deepClone(this.formData)

                if (network) {
                    this.typeNetworkSelected = network
                    this.selectNetworkForSelectorMode(network)
                }else if (page) {
                    this.toggleSelectPageForSelectorMode(page)
                }else {
                    this.selectNetworkForSelectorMode(this.typeNetworkSelected || [...this.networksSelected][0])
                }

                this.$refs.postCreator.classList.add('annimate-switch-edition-mode');
                this.$refs.postCreator.style.transform = `translateX(calc(-100% + ${this.$refs.containerPhone.clientWidth}px))`
                
                if (this.timeOutAnnimateForm) clearTimeout(this.timeOutAnnimateForm)
                this.timeOutAnnimateForm = setTimeout(() => {
                    this.$refs.postCreator.classList.remove('annimate-switch-edition-mode');
                    this.$refs.postCreator.style.transform = ``
                    this.formShow = "formUnique"
                }, 500);

                if (!localStorage.postCreatorCountUseSelectorMode || localStorage.postCreatorCountUseSelectorMode < 3) {
                    if (!localStorage.postCreatorCountUseSelectorMode) localStorage.setItem('postCreatorCountUseSelectorMode', 1)
                    else localStorage.setItem('postCreatorCountUseSelectorMode', localStorage.postCreatorCountUseSelectorMode + 1)
                }

            }else{
                this.formData = this.deepClone(this.saveAllFormData.main)
                this.$refs.postCreator.classList.add('annimate-switch-edition-mode');
                this.$refs.postCreator.style.transform = `translateX(calc(100% - ${this.$refs.containerPhone.clientWidth}px))`
                if (this.timeOutAnnimateForm) clearTimeout(this.timeOutAnnimateForm)

                this.$nextTick(() => {
                    this.timeOutAnnimateForm = setTimeout(() => {
                        this.$refs.postCreator.classList.remove('annimate-switch-edition-mode');
                        this.$refs.postCreator.style.transform = ``
                        this.formShow = "formMultiple"
                    }, 500);
                })
            }
        },

        async handlerChangePreviewDisplay(state) {
            
            this.previewEnabled = state
            if (state) {

                if (!this.selectorMode.selection.page) {
                    for (let i = 0; i < this.listNetworkSort.length; i++) {
                        const page = this.pagesSelected.find(p => p.network == this.listNetworkSort[i])
                        if (page) {
                            this.$set(this.selectorMode.selection, 'page' ,page)
                            break
                        }
                    }
                }
                this.$set(this.selectorMode.selection, 'network' ,null)
                this.saveAllFormData.main = this.deepClone(this.formData)
                

                this.formShow = this.selectorMode.active ? "preview-left" : "preview-right"
               
                if (this.timeOutAnnimateForm) clearTimeout(this.timeOutAnnimateForm)
                this.dataFormRequest = await this.generateDataFormRequest()
                this.$nextTick(() => {
                    this.timeOutAnnimateForm = setTimeout(() => {
                        this.$refs.postCreator.classList.add('annimate-switch-preview-mode');
                    }, 500);
                })

            }else{
                this.$refs.postCreator.classList.remove('annimate-switch-preview-mode');

                if (this.timeOutAnnimateForm) clearTimeout(this.timeOutAnnimateForm)
                this.$nextTick(() => {
                    this.timeOutAnnimateForm = setTimeout(() => {
                        if (this.formShow == "preview-left") {
                            this.formShow = "formUnique"
                        }else{
                            this.formShow = "formMultiple"
                        }
                    }, 1000);
                })
            }
        },

        selectTypeNetwork(typeNetwork) {
            if (!this.postNetworkIsValid[typeNetwork].showRender) return
            this.typeNetworkSelected = typeNetwork
        },

        addNetwork() {
            this.$store.commit('selectPage/updateSelectPageListRetracted', false)
        },

        addMode(mode, data = {}) {
            if (!this.modes.includes(mode)) this.modes = [...this.modes,mode]
            this.$set(this.dataMode,mode, data)
        },

        removeMode(mode = 'all') {
            if (mode == 'all') {
                this.modes = []
                return
            }
            this.modes = this.modes.filter(v => v !== mode)
        },

        clickPageInRenderPost(idPage) {
            const page = this.pagesSelected.find(p => p.id == idPage)
            if (page) {
                if (this.selectorMode.active) {
                    this.toggleSelectPageForSelectorMode(page)
                }else{
                    this.handleChangeSelectorMode(true, null, page)
                }
            }
        },

        selectNetworkForSelectorMode(network) {
            if (this.previewEnabled) return
            // this.saveFormData()
            this.$set(this.selectorMode.selection, 'page', null)
            this.$set(this.selectorMode.selection, 'network', network)
            this.typeNetworkSelected = network
            this.generateFormData(null, network)
        },

        toggleSelectPageForSelectorMode(page) {
            // this.saveFormData()
            this.$set(this.selectorMode.selection, 'network', null)
            this.$set(this.selectorMode.selection, 'page', page)
            this.typeNetworkSelected = page.network
            this.generateFormData(page,null)
        },

        findDifferences(defaultObj, modifiedObj) {
            let differences = {};
            if (Object.keys(defaultObj).length !== Object.keys(modifiedObj).length) return modifiedObj
            if (Object.keys(defaultObj).join('') !== Object.keys(modifiedObj).join('')) return modifiedObj
            // Parcourir les propriétés de l'objet par défaut
            for (let key in defaultObj) {
      
                if (defaultObj.hasOwnProperty(key)) {
                    // Si la valeur est un objet, faire une récursion
              
                    if (typeof defaultObj[key] === 'object' && defaultObj[key] !== null) {
               
                        if (Array.isArray(defaultObj[key])) {
                            // Comparer les tableaux
                            if (JSON.stringify(defaultObj[key]) !== JSON.stringify(modifiedObj[key])) {
                                differences[key] = modifiedObj[key];
                            }
                        } else if (defaultObj[key] instanceof Set) {
                            // Comparer les Set
                            if (JSON.stringify([...defaultObj[key]]) !== JSON.stringify([...modifiedObj[key]])) {
                                differences[key] = modifiedObj[key];
                            }
                        } else {
               
                            // Comparer les objets (récursion)
                            if (key == "playlistSelectedByPage") {
                                console.log("playlistSelectedByPage",JSON.stringify(defaultObj[key]),JSON.stringify(modifiedObj[key]))
                            }
                            const objDiff = this.findDifferences(defaultObj[key], modifiedObj[key], key == "playlistSelectedByPage" ? true : false);
                            if (key == "playlistSelectedByPage") {
                                console.log(objDiff)
                            }
                            if (Object.keys(objDiff).length > 0) {
                                differences[key] = objDiff;
                            }
                        }
                    } else {
                        // Comparer les valeurs primitives
                        if (defaultObj[key] !== modifiedObj[key]) {
                            differences[key] = modifiedObj[key];
                        }
                    }
                }
            }

            return differences;
        },

        mergeUpdates(defaultObj, updateObj) {
            for (let key in updateObj) {
                if (updateObj.hasOwnProperty(key)) {
                    // Si la valeur est un objet, on doit faire une fusion récursive
                    if (typeof updateObj[key] === 'object' && updateObj[key] !== null && !Array.isArray(updateObj[key])) {
                        // Si l'objet par défaut n'a pas cette clé, on initialise un objet vide
                        if (!defaultObj[key]) {
                            defaultObj[key] = {};
                        }
                        // Fusion récursive
                        this.mergeUpdates(defaultObj[key], updateObj[key]);
                    } else {
                        // Sinon, on remplace directement la valeur
                        defaultObj[key] = updateObj[key];
                    }
                }
            }
        },

        generateFormData(page = null, network = null) {
            if (!this.selectorMode.active && !this.previewEnabled) return
            let formDataRef = this.deepClone(this.saveAllFormData.main)
            
            if (page) {
                if (this.saveAllFormData.networks[page.network]) this.mergeUpdates(formDataRef,this.saveAllFormData.networks[page.network])
                if (this.saveAllFormData.pages[page.id]) this.mergeUpdates(formDataRef,this.saveAllFormData.pages[page.id])
            }else if(network) {
                this.mergeUpdates(formDataRef,this.saveAllFormData.networks[network])
            }
            this.formData = formDataRef
        },

        restoreFormData(key) {
            
            if (this.selectorMode.selection.network) {
                if (this.saveAllFormData.networks[this.selectorMode.selection.network])  this.$delete(this.saveAllFormData.networks[this.selectorMode.selection.network], key)
            }else if(this.selectorMode.selection.page){
                if (this.saveAllFormData.pages[this.selectorMode.selection.page.id])  this.$delete(this.saveAllFormData.pages[this.selectorMode.selection.page.id], key)
            }else{
                return
            }

            if (this.selectorMode.active) {
                this.generateFormData(this.selectorMode.selection.page, this.selectorMode.selection.network)
            }
        },

        saveFormData() {
            console.log("saveFormData")
            if (this.previewEnabled) return

            if (!this.selectorMode.active) {
                this.$set(this.saveAllFormData, 'main', this.deepClone(this.formData))
            }else{
                let formDataRef = this.deepClone(this.saveAllFormData.main)
                if (this.selectorMode.selection.network) {
                    console.log('saveFormData selection.network',formDataRef,this.formData)
                    const update = this.findDifferences(formDataRef, this.formData)
                    console.log('saveFormData selection.network', JSON.stringify(update))
                    this.$set(this.saveAllFormData.networks, this.selectorMode.selection.network, update)
                }else if(this.selectorMode.selection.page){
                    if (this.saveAllFormData.networks[this.selectorMode.selection.page.network]) this.mergeUpdates(formDataRef, this.saveAllFormData.networks[this.selectorMode.selection.page.network])
                    const update = this.findDifferences(formDataRef, this.formData)
                    this.$set(this.saveAllFormData.pages, this.selectorMode.selection.page.id, update)
                }   
            }
                
        },

        deepClone(obj) {
            // Vérifier si c'est un objet ou un tableau
            if (obj === null || typeof obj !== 'object') {
                return obj;
            }

            // Gérer les dates
            if (obj instanceof Date) {
                return new Date(obj);
            }

            // Gérer les tableaux
            if (Array.isArray(obj)) {
                return obj.map(item => this.deepClone(item));
            }

            // Gérer les objets Set
            if (obj instanceof Set) {
                return new Set([...obj].map(item => this.deepClone(item)));
            }

            // Gérer les objets Map
            if (obj instanceof Map) {
                return new Map(Array.from(obj.entries()).map(([key, value]) => [this.deepClone(key), this.deepClone(value)]));
            }

            // Gérer les autres objets (Object)
            const copy = {};
            for (let key in obj) {
                if (obj.hasOwnProperty(key)) {
                    copy[key] = this.deepClone(obj[key]);
                }
            }
            
            return copy;
        },

        uploadFileWithProgress(file, idFile) {
            if (this.uploadFilesServer[idFile] && !this.uploadFilesServer[idFile].isUpload && !this.uploadFilesServer[idFile].uploadProgress) return
           
            this.$set(this.uploadFilesServer,idFile, {
                isUpload : false,
                uploadProgress: true,
                percentUpload : 0,
                url: null
            })

            

            const { VUE_APP_VIDEO_API_HOST } = process.env 

            let formData = new FormData()
            formData.append('file', file)
            const user = JSON.parse(localStorage.user)
            console.log("DEBUT");
            let source = new SSE(`${VUE_APP_VIDEO_API_HOST}/image/progress?u=${user.id}`, {payload: formData});
            
            return new Promise(async (resolve, reject) => {
                source.onopen = () => {
                    this.$set(this.uploadFilesServer[idFile],'percentUpload',1)
                };
                source.onmessage = (event) => {
                    let response = JSON.parse(event.data);
                    if (response.file_url) {
                        this.$set(this.uploadFilesServer,idFile,{
                            isUpload : true,
                            uploadProgress: false,
                            percentUpload : 100,
                            url: response.file_url
                        })
                        if (file.type.split('/')[0] == "image") this.compressImage(response.file_url)
                        source.close();
                        resolve({body: response});

                    } else if (response.percent) {
                        this.$set(this.uploadFilesServer[idFile],'percentUpload', response.percent)
                    } else if (response.error) {
                        this.$set(this.uploadFilesServer[idFile],'uploadProgress',false)
                        reject(response.error);
                    }
                };
                source.stream((progress) => {
                    if (progress.lengthComputable) {
                        this.$set(this.uploadFilesServer[idFile],'percentUpload', (progress.loaded / progress.total)*100)
                    }
                });
            }); 
        },

        getVideoDuration(url) {
            return new Promise((resolve, reject) => {
                const video = document.createElement('video');
                video.src = url;

                video.addEventListener('loadedmetadata', function() {
                    resolve(video.duration);  // Renvoie la durée en secondes
                });

                video.addEventListener('error', function() {
                    reject('Impossible de charger la vidéo/musique.');
                });
            });
        },

        async deletePostFromClickSelectPage(params) {

            const post = this.dataEditPost.posts.find(post => post.page == params.pageId);
            const page = this.pagesSelected.find((page) => page.id == params.pageId)

            this.$set(this.dataEditPost, 'posts', this.dataEditPost.posts.filter(post => post.page !== params.pageId))
            this.$store.commit('selectPage/updateSelectPagePageSelected', this.pagesSelected.filter(page => page.id !== params.pageId))
            
            EventBus.$emit('requestManagerAdd',async (onSuccess, onProgress, onError)=> {

                try {
                    const response = await this.deletePost({
                        _id: post._id,
                        _bots:[{
                            id: post.bot,
                            page: {
                                network: page.network,
                            }
                        }],
                        page: [{
                            post_number: post.postId,
                            status: post.status
                        }]
                    });

                    if (response.data.success) {
                        onSuccess(`Post supprimé avec succés`);
                    }else{
                        throw new Error(`Échec lors de la suppression du post`);
                    }
                } catch (error) {
                    this.$set(this.dataEditPost, 'posts', [...this.dataEditPost.posts, post])
                    this.$store.commit('selectPage/updateSelectPagePageSelected', [...this.pagesSelected, post])
                    onError(error.message);
                }  
            }, {
                picture: page.avatar,
                title:`<span class="pink">${page.name.charAt(0).toUpperCase() + page.name.slice(1)}</span>: post planifié`,
                loadingText: "En cours de suppression...",
            })
        },
        
        async sendPostAllPost() {
            const requestGroup = []
        
            switch (this.mode) {
                case 'create': {
                    for (const [pageId, formData] of Object.entries(this.dataFormRequest)) {
                        if (!formData.hasOwnProperty('error')) {
                            const page = this.pagesSelected.find(page => page.id == pageId) || this.allPages.find(page => page.id == pageId)
                            requestGroup.push({
                                start : async (onSuccess, onProgress, onError) => {
                                    try {
                                        const response = await this.new(formData);
                                        if (response.data.success) {
                                            onSuccess(`Post ${formData["data[scheduled_date]"] ? 'planifié' : 'publié'} avec succés`);
                                            return {response, formData: { ...formData, pageId }}
                                        }else{
                                            throw new Error(`Echec lors de la ${formData["data[scheduled_date]"] ? 'planification' : 'publication'} du post`);
                                        }
                                    } catch (error) {
                                        onError(error.message);
                                        return {response:null, formData: { ...formData, pageId }}
                                    }
                                },
                                params : {
                                    picture : formData["data[enclosure]"] || page.avatar,
                                    title : `<span class="pink">${page.name.charAt(0).toUpperCase() + page.name.slice(1)}</span>: ${formData["data[title]"] || "post medias"}`,
                                    loadingText: !formData["data[scheduled_date]"] ? "En cours de publication..." : "En cours de planification..."
                                }
                            });
                        }
                    
                    }
                    break;
                }
                case 'edit': {
                    for (const [pageId, formData] of Object.entries(this.dataFormRequest)) {
                        if (!formData.hasOwnProperty('error')) {
                            const page = this.pagesSelected.find(page => page.id == pageId) || this.allPages.find(page => page.id == pageId)
                            const post = this.dataEditPost.posts.find(post => post.page == pageId)
                            
                            if (post) {
                                formData.postId = post.postId
                                formData.id = post._id
                                
                                requestGroup.push({
                                    start : async (onSuccess, onProgress, onError) => {
                                        try {
                                            const response = await this.putPost(formData);
                                            if (response.data.success) {
                                                onSuccess(`Post ${formData["data[scheduled_date]"] ? 'planifié' : 'publié'} avec succés`);
                                                return {response, formData: { ...formData, pageId }}
                                            }else{
                                                throw new Error(`Echec lors de la ${formData["data[scheduled_date]"] ? 'planification' : 'publication'} du post`);
                                            }
                                        } catch (error) {
                                            onError(error.message);
                                            return {response:null, formData: { ...formData, pageId }}
                                        }
                                    },
                                    params : {
                                        picture : formData["data[enclosure]"] || page.avatar,
                                        title : `<span class="pink">${page.name.charAt(0).toUpperCase() + page.name.slice(1)}</span>: ${formData["data[title]"] || "post medias"}`,
                                        loadingText: !formData["data[scheduled_date]"] ? "En cours de publication..." : "En cours de planification..."
                                    }
                                });
                            }else{
                                requestGroup.push({
                                    start : async (onSuccess, onProgress, onError) => {
                                        try {
                                            const response = await this.new(formData);
                                            if (response.data.success) {
                                                onSuccess(`Post ${formData["data[scheduled_date]"] ? 'planifié' : 'publié'} avec succés`);
                                                return {response, formData: { ...formData, pageId }}
                                            }else{
                                                throw new Error(`Echec lors de la ${formData["data[scheduled_date]"] ? 'planification' : 'publication'} du post`);
                                            }
                                        } catch (error) {
                                            onError(error.message);
                                            return {response:null, formData: { ...formData, pageId }}
                                        }
                                    },
                                    params : {
                                        picture : formData["data[enclosure]"] || page.avatar,
                                        title : `<span class="pink">${page.name.charAt(0).toUpperCase() + page.name.slice(1)}</span>: ${formData["data[title]"] || "post medias"}`,
                                        loadingText: !formData["data[scheduled_date]"] ? "En cours de publication..." : "En cours de planification..."
                                    }
                                });
                            }
                        }  
                    }
                    break;
                }

                case 'draft': {
                    for (const [pageId, formData] of Object.entries(this.dataFormRequest)) {
                        if (!formData.hasOwnProperty('error')) {
                            const page = this.pagesSelected.find(page => page.id == pageId) || this.allPages.find(page => page.id == pageId)
                            requestGroup.push({
                                start : async (onSuccess, onProgress, onError) => {
                                    try {
                                        const response = await this.new({
                                            ...formData,
                                            "data[removeDraft]": this.draft.id
                                        });
                                        if (response.data.success) {
                                            onSuccess(`Post ${formData["data[scheduled_date]"] ? 'planifié' : 'publié'} avec succés`);
                                            return {response, formData: { ...formData, pageId }}
                                        }else{
                                            throw new Error(`Echec lors de la ${formData["data[scheduled_date]"] ? 'planification' : 'publication'} du post`);
                                        }
                                    } catch (error) {
                                        onError(error.message);
                                        return {response:null, formData: { ...formData, pageId }}
                                    }
                                },
                                params : {
                                    picture : formData["data[enclosure]"] || page.avatar,
                                    title : `<span class="pink">${page.name.charAt(0).toUpperCase() + page.name.slice(1)}</span>: ${formData["data[title]"] || "post medias"}`,
                                    loadingText: !formData["data[scheduled_date]"] ? "En cours de publication..." : "En cours de planification..."
                                }
                            });
                        }
                    
                    }
                    break;
                }
            }
            

            EventBus.$emit('requestManagerAddGroup',requestGroup, async(responses)=> {
                try {
                    const posts = responses.filter(({response}) => response.data.success && response.data.news && response.data.post && response.data.post.success).map(({response, formData}) => ({
                        _id: response.data.news._id,
                        bot: formData.bot,
                        page: formData.pageId,
                        postId: response.data.post.post,
                        status: 1,
                        story: null,
                    }))

                    if (posts.length > 1) {
                        const res = await this.updatePostsMultiPages(posts)
                    }
                   
                    if(this.mode == 'draft' && responses.length == posts.length) {
                        try {
                            this.deleteDraft(this.draft.id)
                        } catch (error) {
                            console.error("Echec de la supression du draft")
                        }
                    }
                  
                } catch (error) {
                    console.error(error.message)
                }
            })   

            this.$router.push({
                name: 'planner',
            })
        },

        async saveDraft() {
            
            this.saveFormData()

            const draft = this.generateDraft(
                this.saveAllFormData, 
                this.pagesSelected
            )
            if (this.mode == 'draft') {
                EventBus.$emit('requestManagerAdd',async (onSuccess, onProgress, onError, openWindow)=> {

                    try {
                        const response = await this.updateDraft({
                            ...draftConstante,
                            ...draft, 
                            id: this.draft.id
                            
                        });

                        if (response.data.success) {
                            onSuccess(`Brouillon enregistrer avec succés`);
                            this.draft = {
                                data : draft,
                                id : this.draft.id
                            }
                            this.$store.commit('postCreator/setDataForDraft', this.draft);
                            openWindow()
                        }else{
                            throw new Error(`Échec de l'enregistrement du brouillon`);
                        }
                    } catch (error) {
                        onError(error.message);
                        openWindow()
                    }  
                }, {
                    picture: draft.form.enclosure,
                    title:`<span class="pink">Enregistrement du brouillon</span>`,
                    loadingText: "En cours'...",
                })
            }else if (this.mode == 'edit'){
                EventBus.$emit('requestManagerAdd',async (onSuccess, onProgress, onError, openWindow)=> {

                    try {
                        const response = await this.newDraft({
                            ...draftConstante,
                            ...draft, 
                        });

                        if (response.data.success) {

                            const promises = this.dataEditPost.posts.map(async (post) => {
                                try {
                                    const res = await this.deletePost({
                                        _id: post._id,
                                        _bots: [{
                                            id: post.bot,
                                            page: {
                                                network: (this.pagesSelected.find((page) => page.id == post.page) || this.allPages.find((page) => page.id == post.page)).network,
                                            }
                                        }],
                                        page: [{
                                            post_number: post.postId,
                                            status: post.status
                                        }]
                                    });

                                    if (res.data.success) {
                                        return { success: true };
                                    } else {
                                        throw new Error(`Impossible de supprimer le post ${post._id}`);
                                    }
                                } catch (error) {
                                    return { success: false, error: error.message };
                                }
                            });

                            // Attendre que toutes les promesses soient résolues
                            const results = await Promise.allSettled(promises);

                            const errors = results.filter(result => result.status === 'rejected' || (result.value && !result.value.success));

                            if (errors.length > 0) {
                                if (this.dataEditPost.posts.length == 1) {
                                    onError(this.dataEditPost.posts.length > 1 ? `Attention: Un post planifié n'a pas pu etre retirer` : `Attention : Le post planifié n'a pas pû être retiré, mais le brouillon a bien été créé.`);
                                } else {
                                    onError(`Attention : Certain des post n'ont pas pû être retiré, mais le brouillon a bien été créé.`);
                                }
                            } else {
                                onSuccess(`Succès de la conversion en brouillon.`);
                            }

                            this.draft = {
                                data : draft,
                                id : response.data.draft.id
                            }
                            
                            this.$store.commit('postCreator/setDataForDraft', this.draft);
                            openWindow()
                            this.$router.push('/dash/postCreator/draft');
                        }else{
                            throw new Error(`Échec de la conversion en brouillon`);
                        }

                    } catch (error) {
                        onError(error.message);
                        openWindow()
                    }  
                    }, {
                    picture: draft.form.enclosure,
                    title:`<span class="pink">Conversion en brouillon</span>`,
                    loadingText: "En cours de conversion...",
                })
            }else{
                EventBus.$emit('requestManagerAdd',async (onSuccess, onProgress, onError, openWindow)=> {

                    try {
                        const response = await this.newDraft({
                           ...draftConstante,
                            ...draft, 
                            
                        });

                        if (response.data.success) {
                            onSuccess(`Création du brouillon avec succés`);
                            this.draft = {
                                data : draft,
                                id : response.data.draft.id
                            }
                            this.$store.commit('postCreator/setDataForDraft', this.draft);
                            openWindow()
                            this.$router.push('/dash/postCreator/draft');
                        }else{
                            throw new Error(`Échec de la création du brouillon`);
                        }
                    } catch (error) {
                        onError(error.message);
                        openWindow()
                    }  
                    }, {
                    picture: draft.form.enclosure,
                    title:`<span class="pink">Mise en brouillon</span>`,
                    loadingText: "En cours de création...",
                })
            }
        },

        async generateDataFormRequest() {
            

            const getErrorObject = (text) => {
                console.log("getErrorObject")
                throw new Error(text)
            };

            const replaceMentionsInTextDefault = (text, mentions) => {
                return text.trim().replace(/@(\d{13})/g, (match, id) => {
                    const mention = mentions[id];
                    if (mention) {
                        return mention.textDefault || '';
                    }
                    return match;
                });
            }
       
            const pagesDataForm =  await Promise.all(this.pagesSelected.map(async page => {

                try {
                    if (!page.bots[0] || !page.bots[0].id) return getErrorObject("Les services de cette page ne sont pas activés, veuillez reconnecter la ou contacter un administrateur")

                    let formDataRef = this.deepClone(this.saveAllFormData.main)
                    if (this.saveAllFormData.networks[page.network]) this.mergeUpdates(formDataRef,this.saveAllFormData.networks[page.network])
                    if (this.saveAllFormData.pages[page.id]) this.mergeUpdates(formDataRef,this.saveAllFormData.pages[page.id])
                  
                    const dataFormRequest = {
                        bot: page.bots[0].id,
                        service: 'dashboard',
                        scheduled : formDataRef.planifiedDate && formDataRef.planifiedDate.date ? true : false,
                        'data[allBots]' : this.pagesSelected.map(page => page.bots && page.bots.length && page.bots[0].id ? page.bots[0].id : null).join(','),
                        'data[videoType]' : page.network,
                        'data[scheduled_date]' : formDataRef.planifiedDate && formDataRef.planifiedDate.date ? new Date(`${formDataRef.planifiedDate.date}T${formDataRef.planifiedDate.hours.replace('h',':')}:00`).toISOString() : undefined,
                    }

                    const formNetwork = formDataRef.formDataNetwork[page.network]
                    let files = this.getFilesByNetwork(formDataRef.files, [page.network], {[page.network]: formDataRef.formDataNetwork[page.network]}, this.uploadFilesServer, true)[page.network]
                    
                    const postValidator =  this.postNetworkValidator([page.network], {[page.network]: files}, {[page.network]: formDataRef.formDataNetwork[page.network]},this.unescapeSpecialChars(formDataRef.textContent))
                    if (!postValidator[page.network].isValid) {
                        return getErrorObject(postValidator[page.network].error[0].textError)
                    }

                    switch (page.network) {
                        case 'instagram': {

                            const replaceMentions = (text, mentions) => {
                                return text.trim().replace(/@(\d{13})/g, (match, id) => {
                                    const mention = mentions[id];
                                    if (mention) {
                                        return mention.mention && mention.mention.instagram ? `@${mention.mention.instagram.id}` : mention.textDefault;
                                    }
                                    return match;
                                });
                            }
                        
                            dataFormRequest['data[title]'] = replaceMentions(this.unescapeSpecialChars(formDataRef.textContent), formDataRef.mentions);

                            if (formDataRef.textComment && formDataRef.textComment.trim().length) {
                                dataFormRequest["data[comments]"] = JSON.stringify([replaceMentions(this.unescapeSpecialChars(formDataRef.textComment), formDataRef.mentions)]);
                            }

                            if (formNetwork.collaborators.length || formNetwork.personsIdentified.length) {
                                dataFormRequest['data[userTags]'] = JSON.stringify({
                                    list : formNetwork.collaborators.concat(formNetwork.personsIdentified).reduce((unique, mention) => {
                                            if(!unique.some(obj => obj.id === mention.id)) {
                                                const index = files.findIndex(file => file.id == mention.idFile)
                                                unique.push({
                                                    name : mention.name,
                                                    x : String(mention.x/100),
                                                    y : String(mention.y/100),
                                                    username: mention.id,
                                                    id: mention.pk,
                                                    index : index >= 0 ? index : 0
                                                });
                                            }
                                            return unique;
                                        },[]),
                                    collab : formNetwork.collaborators.length ? [formNetwork.collaborators[0].pk] : []
                                })
                            }
                            
                            
                            if (formNetwork.place && formNetwork.place.id) {
                                dataFormRequest['data[location]'] = formNetwork.place.id
                            }

                            if (files.length > 0 && files[0].type2 === "image") {
                                dataFormRequest['data[enclosure]'] = this.uploadFilesServer[formDataRef.files[0].id].url;   
                            }

                            if (files.length == 1 && files[0].type2 === "video") {

                                dataFormRequest['data[videoReel]'] = true //pas obligatoire, marche sans
                                dataFormRequest['data[video]'] = this.uploadFilesServer[files[0].id].url

                                if (formNetwork.music) {
                                    let duration;
                                    try {
                                        duration = await this.getVideoDuration(this.uploadFilesServer[files[0].id].url) * 1000
                                    } catch (error) {
                                        console.error('Erreur lors de la récupération de la durée:', error);
                                        duration = 0
                                    } 

                                    dataFormRequest['data[reelStickerConfig]'] = JSON.stringify({
                                        "texts":[],
                                        "music" : {
                                            ...formNetwork.music,
                                            "duration":duration,
                                            "startTime": formNetwork.music.track.highlight_start_times_in_ms[0],
                                            "start": formNetwork.music.track.highlight_start_times_in_ms[0],
                                            "end": formNetwork.music.track.highlight_start_times_in_ms[0] + duration,
                                            "config":false,
                                            "paused":true,
                                            
                                        
                                        },
                                        "gifs" :[]
                                    })
                                }
                            } else {

                                if (files.find(file => file.type2 == "video")) {
                                    dataFormRequest['data[typePost]'] = 'video'
                                    dataFormRequest['data[postImage]'] = false
                                    dataFormRequest['data[multipleMedias]'] = JSON.stringify(
                                        files.map((file, index) => {
                                            return {
                                                id: file.id,
                                                url: this.uploadFilesServer[file.id].url,
                                                name: file.filename,
                                                type: file.type,
                                                size: file.size,
                                            };
                                        }),
                                    );
                                }else{
                                    dataFormRequest['data[carrousel]'] = JSON.stringify(
                                        files.map((file, index) => {
                                            return {
                                                url: this.uploadFilesServer[file.id].url,
                                                filename: file.filename,
                                                ratio: String(formNetwork.ratio == '16:9' ? 1.91 : formNetwork.ratio.split(':').reduce((a, b) => a / b)),
                                                facebook: index,//? ne sert a rien
                                                twitter: index,//? ne sert a rien
                                                linkedin: index,//? ne sert a rien
                                                uploaded: true
                                            };
                                        }),
                                    );
                                }
                        
                            }

                            if (formNetwork.shareInStory) {
                                // dataFormRequest['data[background_color]'] = '#dcd2ce'
                                dataFormRequest['data[storification]'] =  JSON.stringify({
                                    "scheduling": formDataRef.planifiedDate && formDataRef.planifiedDate.date ? new Date(`${formDataRef.planifiedDate.date}T${formDataRef.planifiedDate.hours.replace('h',':')}:00`).toISOString() : new Date().toISOString(),
                                    "link":null,
                                    "poll":null,
                                    "slider":null,
                                    "mentions":[],
                                    "hashtags":[],
                                    "location":null,
                                    "texts":[]
                                })
                            }
                            break;
                        }
                        case 'facebook': {
                            const replaceFacebookMentions = (text, mentions) => {
                                return text.trim().replace(/@(\d{13})/g, (match, id) => {
                                    const mention = mentions[id];
                                    if (mention) {
                                        return mention.mention && mention.mention.facebook 
                                            ? `@[${mention.mention.facebook.name} (${mention.mention.facebook.id})]` 
                                            : mention.textDefault;
                                    }
                                    return match;
                                });
                            }

                            
                            dataFormRequest['data[title]'] = replaceFacebookMentions(
                                this.unescapeSpecialChars(formDataRef.textContent), 
                                formDataRef.mentions
                            );

                            
                            if (formDataRef.textComment && formDataRef.textComment.trim().length) {
                                dataFormRequest["data[comments]"] = JSON.stringify([
                                    replaceFacebookMentions(
                                        this.unescapeSpecialChars(formDataRef.textComment), 
                                        formDataRef.mentions
                                    )
                                ]);
                            }


                            if (formNetwork.place && formNetwork.place.id) {
                                dataFormRequest['data[location]'] = formNetwork.place.id
                            }

                            if (formNetwork.snippet && formNetwork.snippet.link) {
                                    dataFormRequest['data[url]'] = formNetwork.snippet.link
                                    dataFormRequest['data[postImage]'] = false
                                    dataFormRequest['data[videoType]'] = 'facebook'
                                    dataFormRequest['data[typePost]'] = 'standard'
                            }else{
                                if (formNetwork.typeMedia == 'image') {

                                    if (files.length == 1) {
                                        dataFormRequest['data[postImage]'] = true
                                        dataFormRequest['data[typePost]'] = 'image'
                                        dataFormRequest['data[enclosure]'] = this.uploadFilesServer[files[0].id].url
                                    }

                                    if (files.length > 1) {
                                        dataFormRequest['data[postImage]'] = true
                                        dataFormRequest['data[typePost]'] = 'image'
                                        dataFormRequest['data[carrousel]'] = 'image'

                                        dataFormRequest['data[carrousel]'] = JSON.stringify(
                                            files.map((file, index) => {
                                            
                                                return {
                                                    url: this.uploadFilesServer[file.id].url,
                                                    filename: file.filename,
                                                    size: file.size,
                                                    id: file.id,
                                                    ratio : 1,//? ne sert a rien
                                                    facebook: index,//? ne sert a rien
                                                    twitter: index,//? ne sert a rien
                                                    linkedin: index,//? ne sert a rien
                                                    uploaded: true
                                                };
                                            }),
                                        );
                                    }
                                
                                }

                                if (formNetwork.typeMedia == 'video') {
            
                                    const file = formDataRef.files.find(file => file.type2 == 'video')
                                
                                    if (file) {
                                        dataFormRequest['data[postImage]'] = false
                                        dataFormRequest['data[videoType]'] = 'facebook'
                                        dataFormRequest['data[typePost]'] = 'video'
                                        dataFormRequest['data[video]'] =  this.uploadFilesServer[file.id].url

                                        if (file.imagePreview && file.imagePreview.id && this.uploadFilesServer[file.imagePreview.id] && this.uploadFilesServer[file.imagePreview.id].isUpload) {
                                            dataFormRequest['data[enclosure]'] = this.uploadFilesServer[file.imagePreview.id].url
                                        }
                                    }
                                
                                }    
                            }
                            break;
                        }
                        case 'linkedin' : {

                            const replaceLinkedInMentions = (text, mentions) => {
                                return text.trim().replace(/@(\d{13})/g, (match, id) => {
                                    const mention = mentions[id];
                                    if (mention) {
                                        return mention.mention && mention.mention.linkedin 
                                            ? `@[${mention.mention.linkedin.name} (${mention.mention.linkedin.id})]` 
                                            : mention.textDefault;
                                    }
                                    return match;
                                });
                            }

                            dataFormRequest['data[title]'] = replaceLinkedInMentions(
                                this.unescapeSpecialChars(formDataRef.textContent), 
                                formDataRef.mentions
                            );

                            if (formDataRef.textComment && formDataRef.textComment.trim().length) {
                                dataFormRequest["data[comments]"] = JSON.stringify([
                                    replaceLinkedInMentions(
                                        this.unescapeSpecialChars(formDataRef.textComment), 
                                        formDataRef.mentions
                                    )
                                ]);
                            }
                                                    

                            if (formNetwork.survey && formNetwork.survey.active) {
                                dataFormRequest['data[postImage]'] = false
                                dataFormRequest['data[videoType]'] = 'linkedin'
                                dataFormRequest['data[typePost]'] = 'poll'
                                dataFormRequest['data[poll]'] =  JSON.stringify({
                                    question : formNetwork.survey.question,
                                    options : formNetwork.survey.options,
                                    duration : { 
                                        oneDay : 86400,
                                        threeDay : 259200,
                                        oneWeek : 604800,
                                        twoWeek : 1209600
                                    }[formNetwork.survey.duration]
                                })
                                // ajout d'un sondage

                            }else{

                                if (formNetwork.snippet && formNetwork.snippet.link) {
                                    dataFormRequest['data[url]'] = formNetwork.snippet.link
                                    dataFormRequest['data[postImage]'] = false
                                    dataFormRequest['data[videoType]'] = 'linkedin'
                                    dataFormRequest['data[typePost]'] = 'standard'
                                }else if (files.length) {
                                    if (formNetwork.typeMedia == 'video') {
                                        const file = files.find(file => file.type2 == 'video')
                
                                        if (file) {
                                            dataFormRequest['data[postImage]'] = false
                                            dataFormRequest['data[videoType]'] = 'linkedin'
                                            dataFormRequest['data[typePost]'] = 'video'
                                            dataFormRequest['data[video]'] =  this.uploadFilesServer[file.id].url

                                            if (file.imagePreview && file.imagePreview.id && this.uploadFilesServer[file.imagePreview.id] && this.uploadFilesServer[file.imagePreview.id].isUpload) {
                                                dataFormRequest['data[enclosure]'] = this.uploadFilesServer[file.imagePreview.id].url
                                            }
                                        }
                                    
                                    }

                                    if (formNetwork.typeMedia == 'image') {

                                        if (files.length == 1) {
                                            dataFormRequest['data[postImage]'] = true
                                            dataFormRequest['data[typePost]'] = 'image'
                                            dataFormRequest['data[videoType]'] = 'linkedin'
                                            dataFormRequest['data[enclosure]'] = this.uploadFilesServer[files[0].id].url
                                        }

                                        if (files.length > 1) {
                                            dataFormRequest['data[postImage]'] = true
                                            dataFormRequest['data[typePost]'] = 'image'
                                            dataFormRequest['data[carrousel]'] = 'image'
                                            dataFormRequest['data[videoType]'] = 'linkedin'

                                            dataFormRequest['data[carrousel]'] = JSON.stringify(
                                                files.map((file, index) => {
                                                    if (!dataFormRequest['data[enclosure]']) {
                                                        dataFormRequest['data[enclosure]'] = this.uploadFilesServer[file.id].url
                                                    }
                                                
                                                    return {
                                                        url: this.uploadFilesServer[file.id].url,
                                                        filename: file.filename,
                                                        file : {
                                                            id: file.id,
                                                        },
                                                        size: file.size,
                                                        id: file.id,
                                                        ratio : 1,//? ne sert a rien
                                                        facebook: index,//? ne sert a rien
                                                        twitter: index,//? ne sert a rien
                                                        linkedin: index,//? ne sert a rien
                                                        uploaded: true
                                                    };
                                                }),
                                            );
                                        }
                                    }

                                    if (formNetwork.typeMedia == 'pdf') {
                                        dataFormRequest['data[postImage]'] = false
                                        dataFormRequest['data[videoType]'] = 'linkedin'
                                        dataFormRequest['data[typePost]'] = 'document'
                                        dataFormRequest['data[documentTitle]'] = formNetwork.pdf && formNetwork.pdf.title ? formNetwork.pdf.title : files[0].name
                                        dataFormRequest['data[enclosure]'] = this.uploadFilesServer[files[0].id].url
                                        
                                    }
                                }
                            }

                            break;
                        }
                        case 'google':{
                            dataFormRequest['data[postImage]'] = true
                            dataFormRequest['data[videoType]'] = 'google'
                            dataFormRequest['data[typePost]'] = 'image'

                            dataFormRequest['data[title]'] = replaceMentionsInTextDefault(this.unescapeSpecialChars(formDataRef.textContent), formDataRef.mentions)
                        
                            if (files.length) {
                                dataFormRequest['data[enclosure]'] = this.uploadFilesServer[files[0].id].url
                            }else{
                                if (formNetwork.snippet && formNetwork.snippet.link) {
                                    try {
                                        const { body } = await this.getNewsMeta(formNetwork.snippet.link)
                                        const imageUrl = body.meta.og && body.meta.og.image ? body.meta.og.image : body.meta.image && body.meta.image[0] ? body.meta.image[0].url : null
                                        if (!imageUrl) return getErrorObject("Veuillez ajouter au moins une image ou un lien.")
                                        dataFormRequest['data[enclosure]'] = imageUrl
                                    } catch (error) {
                                        return getErrorObject("Veuillez ajouter au moins une image ou un lien.")
                                    }
                                }
                            }

                            if (formNetwork.snippet && formNetwork.snippet.link) {
                                dataFormRequest['data[url]'] = formNetwork.snippet.link
                            }
                            break;
                        }
                        case 'threads': {
                            dataFormRequest['data[title]'] = replaceMentionsInTextDefault(this.unescapeSpecialChars(formDataRef.textContent), formDataRef.mentions)
                            
                            if (formDataRef.textComment && formDataRef.textComment.trim().length) {
                                dataFormRequest["data[comments]"] = JSON.stringify([replaceMentionsInTextDefault(this.unescapeSpecialChars(formDataRef.textComment), formDataRef.mentions)])
                            }


                            if (!formDataRef.urlsTextContent.length && formNetwork.snippet && formNetwork.snippet.link) {
                                    dataFormRequest['data[url]'] = formNetwork.snippet.link
                                    dataFormRequest['data[postImage]'] = false
                                    dataFormRequest['data[videoType]'] = 'threads'
                                    dataFormRequest['data[typePost]'] = 'standard'
                            }else{
                               
                                if (files.length == 1) {
                                
                                    if (files[0].type2 == 'image') {
                                        dataFormRequest["data[postImage]"] = true
                                        dataFormRequest["data[videoType]"] = 'threads'
                                        dataFormRequest["data[typePost]"] = 'image'
                                        dataFormRequest['data[enclosure]'] = this.uploadFilesServer[files[0].id].url
                                    }else if(files[0].type2 == 'video') {
                                        dataFormRequest["data[postImage]"] = false
                                        dataFormRequest["data[videoType]"] = 'threads'
                                        dataFormRequest["data[typePost]"] = 'video'
                                        dataFormRequest['data[video]'] = this.uploadFilesServer[files[0].id].url
                                    }
                                }else {
                                    dataFormRequest["data[postImage]"] = false

                                    if (files.find(file => file.type2 == 'video') && files.find(file => file.type2 == 'image')) {
                                        dataFormRequest['data[enclosure]'] = this.uploadFilesServer[files.find(file => file.type2 == 'image').id].url
                                        dataFormRequest["data[postImage]"] = false
                                        dataFormRequest['data[video]'] = this.uploadFilesServer[files.find(file => file.type2 == 'video').id].url
                                        dataFormRequest["data[videoType]"] = 'threads'
                                        dataFormRequest["data[typePost]"] = 'video'

                                        dataFormRequest["data[multipleMedias]"] =  JSON.stringify(files.map((file) => {
                                            return {
                                                id: file.id,
                                                url: this.uploadFilesServer[file.id].url,
                                                name: file.name,
                                                type: file.type,
                                                size: file.size,
                                            }
                                        }))

                                    }else if (files.find(file => file.type2 == 'video')) {
                                        dataFormRequest["data[postImage]"] = false
                                        dataFormRequest['data[video]'] = this.uploadFilesServer[files.find(file => file.type2 == 'video').id].url
                                        dataFormRequest["data[videoType]"] = 'threads'
                                        dataFormRequest["data[typePost]"] = 'video'

                                        dataFormRequest["data[multipleMedias]"] =  JSON.stringify(files.map((file) => {
                                            return {
                                                id: file.id,
                                                url: this.uploadFilesServer[file.id].url,
                                                name: file.name,
                                                type: file.type,
                                                size: file.size,
                                            }
                                        }))

                                    }else if (files.find(file => file.type2 == 'image')) {
                                        dataFormRequest['data[enclosure]'] = this.uploadFilesServer[files[0].id].url
                                        dataFormRequest["data[postImage]"] = true
                                        dataFormRequest["data[videoType]"] = 'threads'
                                        dataFormRequest["data[typePost]"] = 'image'

                                        dataFormRequest["data[carrousel]"] =  JSON.stringify(files.map((file,index) => {

                                            return {
                                                url: this.uploadFilesServer[file.id].url,
                                                filename: file.name,
                                                file: {
                                                    id: file.id
                                                },
                                                size: file.size,
                                                id: file.id,
                                                ratio: 1,
                                                facebook: index,
                                                twitter: index,
                                                linkedin: index,
                                                uploaded: true
                                            }
                                        }))
                                    }
                                }
                            } 
                        

                        

                            break;
                        }
                        case 'twitter': {
                        
                            const replaceTwitterMentions = (text, mentions) => {
                                return text.trim().replace(/@(\d{13})/g, (match, id) => {
                                    const mention = mentions[id];
                                    if (mention) {
                                        return mention.mention && mention.mention.twitter 
                                            ? `@${mention.mention.twitter.username}` 
                                            : mention.textDefault;
                                    }
                                    return match;
                                });
                            }

                            dataFormRequest['data[title]'] = replaceTwitterMentions(
                                this.unescapeSpecialChars(formDataRef.textContent), 
                                formDataRef.mentions
                            );

                            if (formDataRef.textComment && formDataRef.textComment.trim().length) {
                                dataFormRequest["data[comments]"] = JSON.stringify([
                                    replaceTwitterMentions(
                                        this.unescapeSpecialChars(formDataRef.textComment), 
                                        formDataRef.mentions
                                    )
                                ]);
                            }

                            if (formNetwork.snippet && formNetwork.snippet.link) {
                                dataFormRequest["data[url]"] = formNetwork.snippet.link
                                dataFormRequest["data[postImage]"] = false
                                dataFormRequest["data[videoType]"] = 'twitter'
                                dataFormRequest["data[typePost]"] = 'standard'

                            }else if(files.length){

                                if (files[0].type2 == 'image') {

                                    if (files.length == 1) {
                                        dataFormRequest["data[postImage]"] = true
                                        dataFormRequest["data[videoType]"] = 'twitter'
                                        dataFormRequest["data[typePost]"] = 'image'
                                        dataFormRequest['data[enclosure]'] = this.uploadFilesServer[files[0].id].url
                                    }else{
                                    
                                        dataFormRequest["data[postImage]"] = true
                                        dataFormRequest['data[enclosure]'] = this.uploadFilesServer[files.find(file => file.type2 == 'image').id].url
                                        dataFormRequest["data[videoType]"] = 'twitter'
                                        dataFormRequest["data[typePost]"] = 'image'

                                        dataFormRequest["data[carrousel]"] =  JSON.stringify(files.map((file, index) => {

                                            return {
                                                url: this.uploadFilesServer[file.id].url,
                                                filename: file.name,
                                                file: {
                                                    id: file.id,
                                                },
                                                size: file.size,
                                                id: file.id,
                                                ratio: 1,
                                                facebook: index,
                                                twitter: index,
                                                linkedin: index,
                                                uploaded: true
                                            }
                                        }))
                                    }

                                }else if (files[0].type2 == 'video') {
                                    dataFormRequest["data[postImage]"] = false
                                    dataFormRequest["data[videoType]"] = 'twitter'
                                    dataFormRequest["data[typePost]"] = 'video'
                                    dataFormRequest['data[video]'] = this.uploadFilesServer[files[0].id].url
                                }
                            }

                            break;
                        }
                        case 'tiktok': {
                         
                            dataFormRequest['data[title]'] = replaceMentionsInTextDefault(this.unescapeSpecialChars(formDataRef.textContent), formDataRef.mentions)

                            dataFormRequest['data[postImage]'] = false
                            dataFormRequest['data[video]'] = this.uploadFilesServer[files[0].id].url
                            dataFormRequest['data[typePost]'] = 'video'
                            dataFormRequest['data[videoType]'] = 'tiktok'
                            dataFormRequest['data[tiktokOptions]'] = JSON.stringify(
                                {
                                    comment_disabled: formNetwork.commentDisable,
                                    duet_disabled: formNetwork.useVideoForDuo,
                                    stitch_disabled: formNetwork.useVideoForOtherVideo,
                                    privacy_level: {
                                        all: 'PUBLIC_TO_EVERYONE',
                                        friends: 'MUTUAL_FOLLOW_FRIENDS',
                                        me: 'SELF_ONLY',
                                    }[formNetwork.visibility],
                                
                                }
                            )
                          
                            break;
                        }
                        case 'youtube': {

                            dataFormRequest['data[title]'] = replaceMentionsInTextDefault(this.unescapeSpecialChars(formDataRef.textContent.slice(0, 100).split("\\n")[0]), formDataRef.mentions)
                            
                            dataFormRequest['data[description]'] = replaceMentionsInTextDefault(this.unescapeSpecialChars(formDataRef.textContent.split("\\n").slice(1).join("\\n")), formDataRef.mentions)

                            dataFormRequest['data[postImage]'] = false
                            dataFormRequest['data[video]'] = this.uploadFilesServer[files[0].id].url
                            dataFormRequest['data[videoType]'] = 'youtube'
                            dataFormRequest['data[typePost]'] = 'video'

                            dataFormRequest['data[youtubeOption]'] = JSON.stringify({
                                notifySubscribers: formNetwork.notifySubscribers,
                                madeForKids: formNetwork.contentForChildren,
                                privacy_level: {
                                    all: "public",
                                    private: "private",
                                    unlisted: "unlisted"
                                }[formNetwork.visibility],
                                category: formNetwork.category,
                                tag : '', //inutile
                                tags : formNetwork.tags.length ? formNetwork.tags.map(tagName => ({
                                        text: tagName,
                                        tiClasses : ["valid"]
                                    }))
                                    : [],
                                playlist: formNetwork.playlistSelectedByPage[page.id] ? formNetwork.playlistSelectedByPage[page.id] : null
                            })

                           
                            break;
                        }
                        case 'pinterest': {
                            
                            if (!formNetwork.boardSelectedByPage[page.id]) return getErrorObject("Aucun board n'a été sélectionné")
                            dataFormRequest['data[boardSelected]'] = formNetwork.boardSelectedByPage[page.id]

                            if (formNetwork.snippet && formNetwork.snippet.link) {
                                dataFormRequest['data[url]'] = formNetwork.snippet.link
                            }

                            if (!files[0]) {
                                try {
                                    const { body } = await this.getNewsMeta(formNetwork.snippet.link)
                                    const imageUrl = body.meta.og && body.meta.og.image ? body.meta.og.image : body.meta.image && body.meta.image[0] ? body.meta.image[0].url : null
                                    if (!imageUrl) return getErrorObject("Veuillez ajouter au moins une image ou un lien")

                                    dataFormRequest['data[enclosure]'] = imageUrl
                                    dataFormRequest['data[postImage]'] = true
                                    dataFormRequest['data[videoType]'] = 'pinterest'
                                    dataFormRequest['data[typePost]'] = 'image'

                                } catch (error) {
                                    return getErrorObject("Veuillez ajouter au moins une image ou un lien")
                                }
                            }

                            dataFormRequest['data[title]'] = replaceMentionsInTextDefault(this.unescapeSpecialChars(formDataRef.textContent.slice(0, 100).split("\\n")[0]), formDataRef.mentions)
                            dataFormRequest['data[description]'] = replaceMentionsInTextDefault(this.unescapeSpecialChars(formDataRef.textContent.split("\\n").slice(1).join("\\n")), formDataRef.mentions)

                            if (files[0]) {
                                
                                if (files[0].type2 == 'video') {
                                    dataFormRequest['data[postImage]'] = false
                                    dataFormRequest['data[video]'] = this.uploadFilesServer[files[0].id].url
                                    dataFormRequest['data[videoType]'] = 'pinterest'
                                    dataFormRequest['data[typePost]'] = 'video'
                                }else if (files[0].type2 == 'image') {
                                    dataFormRequest['data[enclosure]'] = this.uploadFilesServer[files[0].id].url
                                    dataFormRequest['data[postImage]'] = true
                                    dataFormRequest['data[videoType]'] = 'pinterest'
                                    dataFormRequest['data[typePost]'] = 'image'
                                }
                              
                            }
                            break;
                        }
                        case 'telegram': { 
                            dataFormRequest['data[title]'] = replaceMentionsInTextDefault(this.unescapeSpecialChars(formDataRef.textContent), formDataRef.mentions)
                            dataFormRequest['data[videoType]'] = 'telegram'
                            dataFormRequest['data[typePost]'] = 'standard'

                            if (formDataRef.textComment && formDataRef.textComment.trim().length) {

                                dataFormRequest["data[comments]"] = JSON.stringify([replaceMentionsInTextDefault(this.unescapeSpecialChars(formDataRef.textComment), formDataRef.mentions)])
                            }
                            break;
                        }
                    }

                    return [page.id, dataFormRequest]
                } catch (error) {
                    console.log('error')
                    return [page.id, {
                        error: error.message
                    }]
                }
               
            })); 

            let pagesDataFormObject = Object.fromEntries(pagesDataForm.filter(data => data !== null))

            const idPagesValid = Object.keys(pagesDataFormObject).filter(id => !pagesDataFormObject[id].hasOwnProperty('error'))
            //generer un draft avec que les pages valide
            if (idPagesValid.length) {
                const draft = JSON.stringify(this.generateDraft(
                    this.saveAllFormData, 
                    idPagesValid.map((pageId) => this.pagesSelected.find(page => page.id == pageId) || this.allPages.find(page => page.id == pageId))
                ))


                idPagesValid.forEach(id => {
                    pagesDataFormObject[id]["draft"] = draft
                });
            }

            return pagesDataFormObject
        },

        generateDraft(saveAllFormData, pages) {
            
            saveAllFormData = JSON.parse(JSON.stringify(saveAllFormData))
           
            function replaceUrlBlob(filesArray, uploadFilesServer) {
                let newFiles = []
                filesArray.forEach(file => {
                    if (uploadFilesServer[file.id] && uploadFilesServer[file.id].isUpload && uploadFilesServer[file.id].url) {
                        let newfile = {
                            ...file,
                            url: uploadFilesServer[file.id].url
                        }

                        if (file.imagePreview) {
                            if (uploadFilesServer[file.imagePreview.id] && uploadFilesServer[file.imagePreview.id].isUpload && uploadFilesServer[file.imagePreview.id].url) {
                                newfile.imagePreview.url = uploadFilesServer[file.imagePreview.id].url
                            } else {
                                delete newfile.imagePreview
                            }
                        }

                        newFiles.push(newfile)
                    }
                });
                return newFiles;  // Correction ici
            }

            saveAllFormData.main.files = replaceUrlBlob(saveAllFormData.main.files, this.uploadFilesServer);

            ['networks','pages'].forEach(key => {
                if (saveAllFormData[key] && Object.keys(saveAllFormData[key]).length) {
                    Object.keys(saveAllFormData[key]).forEach(identifier => {
                        if (saveAllFormData[key][identifier].files) {
                            saveAllFormData[key][identifier].files = replaceUrlBlob(saveAllFormData[key][identifier].files,  this.uploadFilesServer)
                        }
                    });
                }
            })
            
            const replaceMentionsInTextDefault = (text, mentions) => {
                return text.trim().replace(/@(\d{13})/g, (match, id) => {
                    const mention = mentions[id];
                    if (mention) {
                        return mention.textDefault || '';
                    }
                    return match;
                });
            }
            const currentDate = new Date()
            let draft = {}

            draft.saveAllFormData = saveAllFormData
            draft.uploadFilesServer = Object.fromEntries(Object.entries(this.uploadFilesServer).filter(([idFile,dataUpload]) => dataUpload.isUpload))
            draft.form = {
                page : 0,
                name : null,
                url: null,
                file: null,
                date: null,
                time: null,
                title: replaceMentionsInTextDefault(this.unescapeSpecialChars(saveAllFormData.main.textContent.slice(0, 100).split("\\n")[0]), saveAllFormData.main.mentions),
            },

    
            draft.scheduling = {
                "lastScheduled": null,
                "show":true,
                "date": saveAllFormData.main.planifiedDate && saveAllFormData.main.planifiedDate.date ? 
                    new Date(`${saveAllFormData.main.planifiedDate.date}T${saveAllFormData.main.planifiedDate.hours.replace('h',':')}:00`).toISOString() 
                    : 
                    currentDate.toISOString(),
                "time":{
                    "HH": saveAllFormData.main.planifiedDate.hours ? saveAllFormData.main.planifiedDate.hours.split('h')[0] : String(currentDate.getHours()),
                    "mm": saveAllFormData.main.planifiedDate.hours ? saveAllFormData.main.planifiedDate.hours.split('h')[1] : String(currentDate.getMinutes())
                }
            }
            draft.scheduling.lastScheduled = draft.scheduling.date

            draft.pages = pages.map(page => page.id)
            draft.bot = pages.map(page => page.bots && page.bots.length && page.bots[0].id ? page.bots[0].id : null)

            //enclosure
            
            const enclosureFile = saveAllFormData.main.files.find(file => file.type2 == 'image' && file.type == 'image/gif' && this.uploadFilesServer[file.id].isUpload && this.uploadFilesServer[file.id].url) 
            || saveAllFormData.main.files.find(file => file.type2 == 'video' && this.uploadFilesServer[file.id].isUpload && this.uploadFilesServer[file.id].url)
            || saveAllFormData.main.files.find(file => file.type2 == 'image' && this.uploadFilesServer[file.id].isUpload && this.uploadFilesServer[file.id].url)

            if (enclosureFile) {
                if (enclosureFile.type2 == 'video') {
                    draft.form.video = this.uploadFilesServer[enclosureFile.id].url
                }else{
                    draft.form.enclosure = this.uploadFilesServer[enclosureFile.id].url
                }
            }
            draft.editPostValue = []

            pages.forEach(page => {

                let formDataRef = this.deepClone(saveAllFormData.main)
                if (saveAllFormData.networks[page.network]) this.mergeUpdates(formDataRef,saveAllFormData.networks[page.network])
                if (saveAllFormData.pages[page.id]) this.mergeUpdates(formDataRef,saveAllFormData.pages[page.id])
                

                let edit = {
                    page : page.id
                }

                if (saveAllFormData.main.planifiedDate.date !== formDataRef.planifiedDate.date || saveAllFormData.main.planifiedDate.hours !== formDataRef.planifiedDate.hours) {
                    if (!formDataRef.planifiedDate.date || !formDataRef.planifiedDate.hours) {
                        edit.scheduling = {
                            "date": currentDate.toISOString(),
                            "time":{
                                "HH": String(currentDate.getHours()),
                                "mm": String(currentDate.getMinutes())
                            }
                        }
                    }else{
                        edit.scheduling = {
                            "date": new Date(`${formDataRef.planifiedDate.date}T${formDataRef.planifiedDate.hours.replace('h',':')}:00`).toISOString(),
                            "time":{
                                "HH": formDataRef.planifiedDate.hours.split('h')[0],
                                "mm": formDataRef.planifiedDate.hours.split('h')[1]
                            }
                        }
                    }
                }

                if (saveAllFormData.main.textContent !== formDataRef.textContent) {
                    edit.title = replaceMentionsInTextDefault(this.unescapeSpecialChars(formDataRef.textContent.slice(0, 100).split("\\n")[0]), formDataRef.mentions)
                }
                

                edit.video = null
                edit.enclosure = null

                const files = this.getFilesByNetwork(formDataRef.files, [page.network], {[page.network]: formDataRef.formDataNetwork[page.network]}, this.uploadFilesServer, true)[page.network]
                
                if (files && files.length) {
                    
                    const fileFind = files.find(file => file.type2 == 'image' && file.type == 'image/gif' && this.uploadFilesServer[file.id].isUpload && this.uploadFilesServer[file.id].url) 
                    || files.find(file => file.type2 == 'video' && this.uploadFilesServer[file.id].isUpload && this.uploadFilesServer[file.id].url)
                    || files.find(file => file.type2 == 'image' && this.uploadFilesServer[file.id].isUpload && this.uploadFilesServer[file.id].url)

                    if (fileFind) {
                        if (fileFind.type2 == 'video') {
                            edit.video = this.uploadFilesServer[fileFind.id].url
                        }else{
                            edit.enclosure = this.uploadFilesServer[fileFind.id].url
                        }
                    }
                }


                if (Object.keys(edit).length > 1) {
                    draft.editPostValue = [...draft.editPostValue, edit]
                }
                

            });  

            return draft   
        },
        
        unescapeSpecialChars(str) {
            // Remplacer les séquences échappées par leurs équivalents littéraux
            return str
                .replace(/\\n/g, '\n')          // Newline '\n'
                .replace(/\\t/g, '\t')          // Tab '\t'
                .replace(/\\r/g, '\r')          // Carriage return '\r'
                .replace(/\\f/g, '\f')          // Form feed '\f'
                .replace(/\\v/g, '\v')          // Vertical tab '\v'
                .replace(/&nbsp;/g, ' ')        // '&nbsp;' -> space ' '
                .replace(/\\\\/g, '\\');        // Backslash '\\'
        },

        getFilesByNetwork(files = this.formData.files, networks = this.listNetworkSort, formDataNetwork = this.formData.formDataNetwork, uploadFilesServer = this.uploadFilesServer, isUploadRequired = false) {
            let filesPerNetwork = {}
            networks.forEach(networkName => {
                filesPerNetwork[networkName] = files.reduce((filesAccumulator,file) => {
                    //echec de de l'upload
                    if (!uploadFilesServer[file.id] || (!uploadFilesServer[file.id].isUpload && (isUploadRequired || !uploadFilesServer[file.id].uploadProgress))) return filesAccumulator
                    if (file.errorNetwork.hasOwnProperty(networkName)) return filesAccumulator
                    
                    switch (networkName) {
                        case 'facebook':
                            if (formDataNetwork.facebook.typeMedia == 'video' && file.type2 !== 'video') return filesAccumulator
                            if (formDataNetwork.facebook.typeMedia == 'image' && (file.type2 !== 'image' || file.type == 'image/gif')) return filesAccumulator
                            break;
                        case 'instagram':
                            if (!['video', 'image'].includes(file.type2) || file.type == 'image/gif') return filesAccumulator
                            break;
                        case 'linkedin':
                            if (formDataNetwork.linkedin.survey && formDataNetwork.linkedin.survey.active) return filesAccumulator
                            if (formDataNetwork.linkedin.typeMedia == 'video' && (file.type2 !== 'video' || filesAccumulator.some(f => f.type2 == 'video'))) return filesAccumulator
                            if (file.type2 !== formDataNetwork.linkedin.typeMedia) return filesAccumulator
                            break;
                        case 'threads':
                            if (!['video', 'image'].includes(file.type2) || file.type == 'image/gif') return filesAccumulator
                            break;
                        case 'twitter':
                            if (formDataNetwork.twitter.typeContent == 'video' && (file.type2 !== 'video' || filesAccumulator.some(f => f.type2 == 'video'))) return filesAccumulator
                            if (file.type2 !== formDataNetwork.twitter.typeContent) return filesAccumulator
                            break;
                        case 'tiktok':
                            if (file.type2 !== 'video' || filesAccumulator.some(f => f.type2 == 'video')) return filesAccumulator
                            break;
                        case 'google':
                            if (file.type2 !== 'image' || file.type == 'image/gif' || filesAccumulator.some(f => f.type2 == 'image')) return filesAccumulator
                            break
                        case 'telegram':
                            return filesAccumulator
                        case 'pinterest':
                            if (!['video', 'image'].includes(file.type2) || file.type == 'image/gif' || filesAccumulator.some(f => ['video', 'image'].includes(f.type2))) return filesAccumulator
                            break;
                        case 'youtube':
                            if (file.type2 !== 'video' || filesAccumulator.some(f => f.type2 == 'video')) return filesAccumulator
                            break;
                        
                        default:

                            break;
                    }

                    return [...filesAccumulator, file]
                },[]).slice(0,maxFilesPerNetwork[networkName])
            })

            return filesPerNetwork
        },

        postNetworkValidator(networks = this.listNetworkSort, filesByNetwork = this.filesSortByNetwork, formDataNetwork = this.formData.formDataNetwork ,text = this.textContentConverted) {
            const validator = {}

            networks.forEach(networkName => {
                validator[networkName] = {
                    isValid : true,
                    showRender : true,
                    error : []
                }

                switch (networkName) {
                    case 'facebook':
                    
                        if (
                            !filesByNetwork[networkName].length &&
                            text.length == 0 &&
                            !formDataNetwork[networkName].snippet.link
                        ) {
                            validator[networkName].error.push({
                                textError : "Veuillez ajouter au moins un média, un contenu ou un lien."
                            })
                            validator[networkName].isValid = false
                            validator[networkName].showRender = false
                        }
                        break;

                    case 'instagram':
                        if (!filesByNetwork[networkName].length) {
                            validator[networkName].error.push({
                                textError : "Veuillez ajouter au moins une image ou une video."
                            })
                            validator[networkName].isValid = false
                            validator[networkName].showRender = false
                        }
                        break;

                    case 'linkedin':
                        if (
                            !filesByNetwork[networkName].length &&
                            text.length == 0 &&
                            !formDataNetwork[networkName].snippet.link &&
                            !formDataNetwork[networkName].survey.active
                        ) {
                            validator[networkName].error.push({
                                textError : "Veuillez ajouter au moins un média, un contenu, un lien ou un sondage."
                            })
                            validator[networkName].isValid = false
                            validator[networkName].showRender = false
                        }
                        break;
                    case 'threads':
                        
                        if (
                            !filesByNetwork[networkName].length &&
                            text.length == 0 &&
                            !formDataNetwork[networkName].snippet.link
                        ) {
                            validator[networkName].error.push({
                                textError : "Veuillez ajouter au moins un média, un contenu ou un lien."
                            })
                            validator[networkName].isValid = false
                            validator[networkName].showRender = false
                        }
                        break;
                    case 'twitter':
                        if (
                            !filesByNetwork[networkName].length &&
                            text.length == 0 &&
                            !formDataNetwork[networkName].snippet.link
                        ) {
                            validator[networkName].error.push({
                                textError : "Veuillez ajouter au moins un média, un contenu ou un lien."
                            })
                            validator[networkName].isValid = false
                            validator[networkName].showRender = false
                        }
                        break;
                    case 'tiktok':
                        if (
                            !filesByNetwork[networkName].length
                        ) {
                            validator[networkName].error.push({
                                textError : "Veuillez ajouter une video."
                            })
                            validator[networkName].isValid = false
                            validator[networkName].showRender = false
                        }
                        break;
                    case 'google':
                        if (
                            !filesByNetwork[networkName].length &&
                            !formDataNetwork[networkName].snippet.link
                        ) {
                            validator[networkName].error.push({
                                textError : "Veuillez ajouter au moins une image ou un lien."
                            })
                            validator[networkName].isValid = false
                            validator[networkName].showRender = false
                        }
                        break;
                    case 'telegram':
                        if (
                            text.length == 0
                        ) {
                            validator[networkName].error.push({
                                textError : "Veuillez ajouter un contenu."
                            })
                            validator[networkName].isValid = false
                            validator[networkName].showRender = false
                        }
                        break;

                    case 'pinterest':
                        if (
                            !filesByNetwork[networkName].length &&
                            !formDataNetwork[networkName].snippet.link
                        ) {
                            validator[networkName].error.push({
                                textError : "Veuillez ajouter au moins une image, une viédo ou un lien."
                            })
                            validator[networkName].isValid = false
                            validator[networkName].showRender = false
                        }
                        break;

                    case 'youtube':
                        if (
                            !filesByNetwork[networkName].length
                        ) {
                            validator[networkName].error.push({
                                textError : "Veuillez ajouter une video."
                            })
                            validator[networkName].isValid = false
                            validator[networkName].showRender = false
                        }
                        break;
                    default:
                        break;
                }
            });
            
            return validator
        },

        switchInterface() {
            localStorage.setItem('postCreatorInterfacePreference', 'old')
            this.$router.push({
                name: 'planner',
                params: {
                newPost: true
                }
            })
        },

        updateTypeNetworkSelected() {

            if (!this.typeNetworkSelected || !this.networksSelected.has(this.typeNetworkSelected) || (!this.postNetworkIsValid[this.typeNetworkSelected].showRender && !this.selectorMode.active)) {
                this.typeNetworkSelected = this.networksSelected.size ? 
                    this.listNetworkSort.find(n => this.networksSelected.has(n) && this.postNetworkIsValid[n].showRender) || '' 
                : ''
            }

            if (!this.typeNetworkSelected && this.networksSelected.size) {
                this.typeNetworkSelected = this.listNetworkSort.find(n => this.networksSelected.has(n))
            }
        }

    },

    computed: {
        allPages() {
            return this.$store.getters['selectPage/selectPageAllPages'];
        },
        pagesSelected() {
            return this.$store.getters['selectPage/selectPagePageSelected'];
        },

        networksSelected() {
            return new Set(this.$store.getters['selectPage/selectPagePageSelected'].map(p => p.network));
        },
       
        phoneIsFirstPlan() {
            let validmodes = ['addCollaboratorMode','addIdentifierMode','addPlaceMode', 'addMusicMode','addMentionMode','addHashtagMode']
            return validmodes.find(v => this.modes.includes(v)) ? true : false
        },

        textContentConverted() {
    
            const regex = /^(<br\s*\/?>|\\n|\s*)+$/i
            if (!this.formData.textContent || regex.test( this.formData.textContent)) return ''
            
            return this.formData.textContent.replaceAll("\\n", '<br>')
        },

        textCommentConverted() {
            const regex = /^(<br\s*\/?>|\\n|\s*)+$/i
            if (!this.formData.textComment || regex.test( this.formData.textComment)) return ''

            return this.formData.textComment ? this.formData.textComment.replaceAll("\\n", '<br>') : ''
        },

        getNamePageNetwork() {
            if ((this.selectorMode.active || this.previewEnabled) && this.selectorMode.selection.page ) return this.selectorMode.selection.page.name

            const page = this.pagesSelected.find(p => p.network == this.typeNetworkSelected)
            return page ? page.name : ''
        },

        filesSortByNetwork() {
            return this.getFilesByNetwork(this.formData.files, this.listNetworkSort, this.formData.formDataNetwork, this.uploadFilesServer)
        },

        postNetworkIsValid() {
            const validator = this.postNetworkValidator(this.listNetworkSort,  this.filesSortByNetwork,  this.formData.formDataNetwork , this.textContentConverted)
            return validator
        },

        countDataFormRequestValid() {
            return Object.values(this.dataFormRequest).filter(form => !form.hasOwnProperty('error')).length
        },

        textBtnFinish() {
            const forms = Object.values(this.dataFormRequest);
            
            const postPlanified = forms.filter(form => !form.hasOwnProperty('error') && form["data[scheduled_date]"]);
            const postInstantly = forms.filter(form => !form.hasOwnProperty('error') && !form["data[scheduled_date]"]);
            
            if (postPlanified.length && postInstantly.length) {
                return "Publier & planifier";
            } else if (postPlanified.length) {
                return `Planifier sur ${postPlanified.length} page${postPlanified.length > 1 ? 's' : ''}`;
            } else if (postInstantly.length) {
                return `Publier sur ${postInstantly.length} page${postInstantly.length > 1 ? 's' : ''}`;
            }

            return '';
        },

        textSwitchPreview() {
            if (this.mode == 'edit') return "Appliquer"
            let postPlanified = false
            let postInstantly = false
            
            const formMain = !this.selectorMode.active ? this.formData : this.saveAllFormData.main

            for (let i = 0; i < this.pagesSelected.length; i++) {
                if (postPlanified && postInstantly) break;
                const page = this.pagesSelected[i];

                const formDataByPage = this.selectorMode.active && this.selectorMode.selection.page && this.selectorMode.selection.page.id == page.id ? this.formData : this.saveAllFormData.pages[page.id]
                const formDataByNetwork = this.selectorMode.active && this.selectorMode.selection.network == page.network ? this.formData : this.saveAllFormData.networks[page.network]
       

                if (formDataByPage && formDataByPage.planifiedDate) {
                    if (formDataByPage.planifiedDate.date || formDataByPage.planifiedDate.hours) {
                        postPlanified = true
                    }else {
                        postInstantly = true
                    }
                }else if(formDataByNetwork && formDataByNetwork.planifiedDate){
                    if (formDataByNetwork.planifiedDate.date || formDataByNetwork.planifiedDate.hours) {
                        postPlanified = true
                    }else {
                        postInstantly = true
                    }
                }else{

                    if (formMain.planifiedDate.date || formMain.planifiedDate.hours) {
                        postPlanified = true
                    } else {
                        postInstantly = true
                    }
                }
            }

            if (postPlanified && postInstantly) {
                return "Publier & planifier";
            } else if (postPlanified) {
                return `Planifier`;
            } else if (postInstantly) {
                return `Publier`;
            }

            return '';
        },

        textPostFailed () {

            if (!Object.values(this.postNetworkIsValid).some(obj => obj.showRender == true)) {
                return 'Veuillez ajouter un média, un contenu ou un lien.'
            }

            if (this.previewEnabled) {
                if (this.selectorMode.selection.page && this.selectorMode.selection.page.id && this.dataFormRequest[this.selectorMode.selection.page.id] && this.dataFormRequest[this.selectorMode.selection.page.id].error) {
                    return this.dataFormRequest[this.selectorMode.selection.page.id].error
                }
            }else{
                if (!this.selectorMode.active  && this.typeNetworkSelected && this.postNetworkIsValid[this.typeNetworkSelected] && !this.postNetworkIsValid[this.typeNetworkSelected].showRender) {
                    return this.postNetworkIsValid[this.typeNetworkSelected].error.length ? this.postNetworkIsValid[this.typeNetworkSelected].error[0].textError : ''
                }

                if (this.selectorMode.active) {
                    if (this.selectorMode.selection.network) {
                        if (!this.postNetworkIsValid[this.selectorMode.selection.network].showRender) return this.postNetworkIsValid[this.selectorMode.selection.network].error.length ? this.postNetworkIsValid[this.selectorMode.selection.network].error[0].textError : ''
                    }else if(this.selectorMode.selection.page && this.selectorMode.selection.page.network){
                        if (!this.postNetworkIsValid[this.selectorMode.selection.page.network].showRender) return this.postNetworkIsValid[this.selectorMode.selection.page.network].error.length ? this.postNetworkIsValid[this.selectorMode.selection.page.network].error[0].textError : ''
                    }
                }
            }

            return ''
        },

        title () {

            switch (this.mode) {
                case "edit":
                    return "Mode édition"
                case "draft":
                    return "Edition du brouillon"
            
                default:
                    return this.previewEnabled ? 'Prévisualisation' : 'Nouvelle publication'
                   
            }
           
           
        }
        
        
    },

    
    watch: {
        networksSelected(newValue, oldValue) {
            this.updateTypeNetworkSelected()
        },
        postNetworkIsValid(validator) {
            console.log('postNetworkIsValid changed')
            this.updateTypeNetworkSelected()
        },
        ["formData.textContent"](newValue, oldValue) {
            if (this.selectorMode.active) this.saveFormData()
        },
        pagesSelected(newValue, oldValue) {
            if (this.mode == 'edit') {
                
                for (let i = 0; i < this.dataEditPost.posts.length; i++) {
                    const post = this.dataEditPost.posts[i];
                    if (!newValue.some(page => page.id == post.page)) {
                        this.$store.commit('selectPage/updateSelectPagePageSelected',oldValue)
                        EventBus.$emit(
                            "showModal", "Attention !", 
                            `Vous êtes sur le point de supprimer le post planifié lié à cette page`, 
                            "Fermer", 
                            "Confirmer", 
                            null, 
                            "deletePostFromClickSelectPage",
                            {
                                pageId : post.page
                            }
                        );
                    }
                  
                }
               
            }
        }
    },

    beforeDestroy () {
        EventBus.$off('postCreatorAddMode', this.addMode);
        EventBus.$off('postCreatorRemoveMode', this.removeMode);
        EventBus.$off('deletePostFromClickSelectPage', this.deletePostFromClickSelectPage);
    }

}
</script>
